// ROLES CHANGE

import { Dispatch } from "redux";
import axios from "../../utils/axios";
import { setUserAuthToken } from "../../utils/headers";
import types from "../actionTypes/user";
import ActionTypes from "./types";
import { UserActions } from "redux/types/user";
import { setAlert } from "redux/actions/alert";
import { datadogRum } from "@datadog/browser-rum";

// LOAD USER
export const loadUser =
  (guestRoleId: any) => async (dispatch: Dispatch<UserActions>) => {
    if (localStorage.user__token) setUserAuthToken(localStorage.user__token, localStorage.use_role_level);
    if (localStorage.use_role_level) localStorage.removeItem("use_role_level");
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };
    const params = new URLSearchParams({
      guestRoleId: guestRoleId,
    }).toString();
    let url;
    if (guestRoleId) url = "user/auth-user-v2?" + params;
    else url = "user/auth-user-v2";

    try {
      const { data } = await axios.get(url, config);
    //   TEST DATA
    //   const data = {
    //     "_id": "6669e3c14934c4853ac35afc",
    //     "username": "srini",
    //     "userLevel": "organization",
    //     "email": "srini@ctrlcampus.com",
    //     "phone": 9182299806,
    //     "roleId" : {
    //         "_id": "6669e3c14934c4853ac35af9",
    //         "name": "Admin",
    //         "organizationId": {
    //             "_id": "65961177dc0e584847990a25",
    //             "account_name": "Gold State University"
    //         },
    //         "roleLevel": "organization",
    //         "isOwner": true
    //     },
    //     "organization" : [
    //         {
    //             "_id": "65961177dc0e584847990a25",
    //             "account_name": "Gold State University",
    //             "s3_uniqId": "1704333687063"
    //         }
    //     ],
    //     "additionalRoles": [],
    //     "orgId": "6669e3c14934c4853ac35af7",
    //     "isTransportNeeded": false,
    //     "isActive": true,
    //     "isDayScholar": false,
    //     "isSemiDayScholar": false,
    //     "isHostler": false,
    //     "status": "ACTIVE",
    //     "date": "2024-06-12T18:06:57.887Z",
    //     "createdAt": "2024-06-12T18:06:57.888Z",
    //     "updatedAt": "2024-06-28T17:33:50.924Z",
    //     "__v": 0,
    //     "address": "",
    //     "fatherName": "",
    //     "firstName": "Srinivasareddy",
    //     "image_path": "1718215617808/Users/1719596022021.jpeg",
    //     "lastName": "D",
    //     "middleName": "",
    //     "motherName": "",
    //     "optForResign": false,
    //     "dashlets": [],
    //     "permissions": [
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702cf8",
    //             "branchModuleId": "6669e4ec4934c4853ac35ebd",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2472",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702cf8",
    //                 "route_path": "organization",
    //                 "alias_name": "Organization",
    //                 "name": "Organization",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702cfa",
    //             "branchModuleId": "6669e4ec4934c4853ac35ebe",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2473",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702cfa",
    //                 "route_path": "org_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42ca5b49011b1702cf8",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702cfc",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2474",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702cfc",
    //                 "route_path": "settings/org_academic_classes",
    //                 "alias_name": "Classes",
    //                 "name": "Classes",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702cfe",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2475",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702cfe",
    //                 "route_path": "settings/create_user",
    //                 "alias_name": "User Management",
    //                 "name": "User Management",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d00",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2476",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d00",
    //                 "route_path": "settings/org_academic_subjects",
    //                 "alias_name": "Subjects",
    //                 "name": "Subjects",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d02",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2477",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d02",
    //                 "route_path": "settings/create_role",
    //                 "alias_name": "Role Management",
    //                 "name": "Role Management",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d04",
    //             "branchModuleId": "6669e4ec4934c4853ac35ebf",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2478",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d04",
    //                 "route_path": "settings/org_academic_batches",
    //                 "alias_name": "Academic Batches",
    //                 "name": "Academic Batches",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d06",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2479",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d06",
    //                 "route_path": "settings/org_branches",
    //                 "alias_name": "Branches",
    //                 "name": "Branches",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d08",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d247a",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d08",
    //                 "route_path": "settings/org_logo_settings",
    //                 "alias_name": "Organization/Branch Logos",
    //                 "name": "Organization/Branch Logos",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d12",
    //             "branchModuleId": "6669e4ec4934c4853ac35ecc",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b749daa1fd1f477a9894d0",
    //                         "name": "finance_fee_details",
    //                         "label": "Fee Details",
    //                         "route_path": "finance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d247c"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b7556ba1fd1f477a9a3002",
    //                         "name": "finance_fee_concession",
    //                         "label": "Fee Concession",
    //                         "route_path": "finance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d247d"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b7556ba1fd1f477a9a3005",
    //                         "name": "finance_fee_cancellation",
    //                         "label": "Fee Cancellation",
    //                         "route_path": "finance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d247e"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b7556ba1fd1f477a9a2ffc",
    //                         "name": "finance_recent_transactions",
    //                         "label": "Recent Transactions",
    //                         "route_path": "finance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d247f"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b7556ba1fd1f477a9a2fff",
    //                         "name": "finance_collection_overview",
    //                         "label": "Collection Overview",
    //                         "route_path": "finance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2480"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d247b",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d12",
    //                 "route_path": "finance",
    //                 "alias_name": "Finance",
    //                 "name": "Finance",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d14",
    //             "branchModuleId": "6669e4ec4934c4853ac35ecd",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2481",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d14",
    //                 "route_path": "fee_counter",
    //                 "alias_name": "Fee Counter",
    //                 "name": "Fee Counter",
    //                 "parentId": "64a3c42ca5b49011b1702d12",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d16",
    //             "branchModuleId": "6669e4ec4934c4853ac35ece",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2482",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d16",
    //                 "route_path": "fee_make_payment",
    //                 "alias_name": "Make Payment",
    //                 "name": "Make Payment",
    //                 "parentId": "64a3c42ca5b49011b1702d14",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d18",
    //             "branchModuleId": "6669e4ec4934c4853ac35ecf",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2483",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d18",
    //                 "route_path": "fee_bulk_upload",
    //                 "alias_name": "Fee Bulk Upload",
    //                 "name": "Fee Bulk Upload",
    //                 "parentId": "64a3c42ca5b49011b1702d14",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d1a",
    //             "branchModuleId": "6669e4ec4934c4853ac35ed0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2484",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d1a",
    //                 "route_path": "fee_management",
    //                 "alias_name": "Fee Management",
    //                 "name": "Fee Management",
    //                 "parentId": "64a3c42ca5b49011b1702d12",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d1c",
    //             "branchModuleId": "6669e4ec4934c4853ac35ed1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2485",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d1c",
    //                 "route_path": "assign_fee_to_students",
    //                 "alias_name": "Assign Fee To Students",
    //                 "name": "Assign Fee To Students",
    //                 "parentId": "64a3c42ca5b49011b1702d1a",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d1f",
    //             "branchModuleId": "6669e4ec4934c4853ac35ed3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2486",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d1f",
    //                 "route_path": "due_reports",
    //                 "alias_name": "Due Reports",
    //                 "name": "Due Reports",
    //                 "parentId": "64a3c42ca5b49011b1702d12",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d27",
    //             "branchModuleId": "6669e4ec4934c4853ac35ed5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2487",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d27",
    //                 "route_path": "class_wise_due_report",
    //                 "alias_name": "Class Wise Due Report",
    //                 "name": "Class Wise Due Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1f",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d32",
    //             "branchModuleId": "6669e4ec4934c4853ac35ed9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2488",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d32",
    //                 "route_path": "collection_reports",
    //                 "alias_name": "Collection Reports",
    //                 "name": "Collection Reports",
    //                 "parentId": "64a3c42ca5b49011b1702d12",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d35",
    //             "branchModuleId": "6669e4ec4934c4853ac35eda",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2489",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d35",
    //                 "route_path": "fee_day_sheet",
    //                 "alias_name": "Fee Day Sheet",
    //                 "name": "Fee Day Sheet",
    //                 "parentId": "64a3c42ca5b49011b1702d32",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d39",
    //             "branchModuleId": "6669e4ec4934c4853ac35edd",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d248a",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d39",
    //                 "route_path": "finance_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d12",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d3e",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d248b",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d3e",
    //                 "route_path": "org_fee_settings",
    //                 "alias_name": "Org Fee Settings",
    //                 "name": "Org Fee Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d40",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d248c",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d40",
    //                 "route_path": "concession_settings",
    //                 "alias_name": "Concession Settings",
    //                 "name": "Concession Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d42",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d248d",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d42",
    //                 "route_path": "create_fine_settings",
    //                 "alias_name": "Fine Settings",
    //                 "name": "Fine Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d44",
    //             "branchModuleId": "6669e4ec4934c4853ac35edf",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d248e",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d44",
    //                 "route_path": "branch_payment_methods",
    //                 "alias_name": "Branch Payment Methods",
    //                 "name": "Branch Payment Methods",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d46",
    //             "branchModuleId": "6669e4ec4934c4853ac35ede",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d248f",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d46",
    //                 "route_path": "finance_settings_banks",
    //                 "alias_name": "Bank Settings",
    //                 "name": "Bank Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d48",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2490",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d48",
    //                 "route_path": "create_fee_receipt_sequence",
    //                 "alias_name": "Fee Receipt Number Settings",
    //                 "name": "Fee Receipt Number Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d4a",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2491",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d4a",
    //                 "route_path": "finance_approval",
    //                 "alias_name": "Approval",
    //                 "name": "Approval",
    //                 "parentId": "64a3c42ca5b49011b1702d12",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d4e",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2492",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d4e",
    //                 "route_path": "fee_payment_change_request",
    //                 "alias_name": "Fee Cancellation Request",
    //                 "name": "Fee Cancellation Request",
    //                 "parentId": "64a3c42da5b49011b1702d4a",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d52",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2493",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d52",
    //                 "route_path": "approve_concession_requests",
    //                 "alias_name": "Concession Requests",
    //                 "name": "Concession Requests",
    //                 "parentId": "64a3c42da5b49011b1702d4a",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d54",
    //             "branchModuleId": "6669e4ec4934c4853ac35eea",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a0d",
    //                         "name": "admissions_analysis",
    //                         "label": "Admissions Analysis",
    //                         "route_path": "admissions"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2495"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a0b",
    //                         "name": "admissions_new_admissions",
    //                         "label": "New Admissions",
    //                         "route_path": "admissions"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2496"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a12",
    //                         "name": "admissions_enquiry",
    //                         "label": "Enquiry",
    //                         "route_path": "admissions"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2497"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a1b",
    //                         "name": "admissions_enquiry_sources",
    //                         "label": "Enquiry Sources",
    //                         "route_path": "admissions"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2498"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a0f",
    //                         "name": "admissions_dynamic_forms",
    //                         "label": "Dynamic Forms",
    //                         "route_path": "admissions"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2499"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d2494",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d54",
    //                 "route_path": "admissions",
    //                 "alias_name": "Admissions",
    //                 "name": "Admissions",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d56",
    //             "branchModuleId": "6669e4ec4934c4853ac35eeb",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d249a",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d56",
    //                 "route_path": "front_office",
    //                 "alias_name": "Enrollments",
    //                 "name": "Enrollments",
    //                 "parentId": "64a3c42da5b49011b1702d54",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d58",
    //             "branchModuleId": "6669e4ec4934c4853ac35eed",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d249b",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d58",
    //                 "route_path": "enquiries",
    //                 "alias_name": "Enquiry",
    //                 "name": "Enquiry",
    //                 "parentId": "64a3c42da5b49011b1702d56",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d5b",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d249c",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d5b",
    //                 "route_path": "enquiry_followup",
    //                 "alias_name": "Enquiry Followup",
    //                 "name": "Enquiry Followup",
    //                 "parentId": "662100e0a1fd1f477a6174e6",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d5d",
    //             "branchModuleId": "6669e4ec4934c4853ac35eee",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d249d",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d5d",
    //                 "route_path": "applications",
    //                 "alias_name": "Applications",
    //                 "name": "Applications",
    //                 "parentId": "64a3c42da5b49011b1702d56",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d5f",
    //             "branchModuleId": "6669e4ec4934c4853ac35eef",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d249e",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d5f",
    //                 "route_path": "enroll_student",
    //                 "alias_name": "Admissions",
    //                 "name": "Admissions",
    //                 "parentId": "64a3c42da5b49011b1702d56",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d61",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d249f",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d61",
    //                 "route_path": "bulk_enroll",
    //                 "alias_name": "Bulk Forms",
    //                 "name": "Bulk Forms",
    //                 "parentId": "662101bca1fd1f477a619155",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d63",
    //             "branchModuleId": "6669e4ec4934c4853ac35efc",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24a0",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d63",
    //                 "route_path": "admissions_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42da5b49011b1702d54",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d65",
    //             "branchModuleId": "6669e4ec4934c4853ac35efd",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24a1",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d65",
    //                 "route_path": "application_number_settings",
    //                 "alias_name": "Application Number Settings",
    //                 "name": "Application Number Settings",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d67",
    //             "branchModuleId": "6669e4ec4934c4853ac35efe",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24a2",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d67",
    //                 "route_path": "admissions_sequence_no",
    //                 "alias_name": "Admission Number Settings",
    //                 "name": "Admission Number Settings",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d69",
    //             "branchModuleId": "6669e4ec4934c4853ac35f01",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24a3",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d69",
    //                 "route_path": "enrollment_sequence_no",
    //                 "alias_name": "Enrollment Code Settings",
    //                 "name": "Enrollment Code Settings",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d6b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f02",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24a4",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d6b",
    //                 "route_path": "admission_mandatory_fields",
    //                 "alias_name": "Admission Fields Setting",
    //                 "name": "Admission Fields Setting",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d6d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f03",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24a5",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d6d",
    //                 "route_path": "enquiry_stages",
    //                 "alias_name": "Enquiry Stages",
    //                 "name": "Enquiry Stages",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d6f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f04",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24a6",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d6f",
    //                 "route_path": "org_sources",
    //                 "alias_name": "Organization Sources",
    //                 "name": "Organization Sources",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 8,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d71",
    //             "branchModuleId": "6669e4ec4934c4853ac35f05",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a0c",
    //                         "name": "hr_attendance_overview",
    //                         "label": "Attendance Overview",
    //                         "route_path": "hr"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24a8"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a0e",
    //                         "name": "hr_attendance_logs",
    //                         "label": "Attendance Log",
    //                         "route_path": "hr"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24a9"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a07",
    //                         "name": "hr_leave_requests",
    //                         "label": "Leave Requests",
    //                         "route_path": "hr"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24aa"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a11",
    //                         "name": "hr_staff_strength",
    //                         "label": "Staff Strength",
    //                         "route_path": "hr"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24ab"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a0a",
    //                         "name": "hr_work_aniversary",
    //                         "label": "Work Aniversary",
    //                         "route_path": "hr"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24ac"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d24a7",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d71",
    //                 "route_path": "hr",
    //                 "alias_name": "HR",
    //                 "name": "HR",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d73",
    //             "branchModuleId": "6669e4ec4934c4853ac35f06",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24ad",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d73",
    //                 "route_path": "staff_enrollment",
    //                 "alias_name": "Staff Enrollment",
    //                 "name": "Staff Enrollment",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d75",
    //             "branchModuleId": "6669e4ec4934c4853ac35f07",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24ae",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d75",
    //                 "route_path": "update_staff_details",
    //                 "alias_name": "Update Staff Details",
    //                 "name": "Update Staff Details",
    //                 "parentId": "64a3c42da5b49011b1702d73",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d7f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f08",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24af",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d7f",
    //                 "route_path": "staff_groups",
    //                 "alias_name": "Staff Groups",
    //                 "name": "Staff Groups",
    //                 "parentId": "64a3c42da5b49011b1702d73",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d81",
    //             "branchModuleId": "6669e4ec4934c4853ac35f0a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b0",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d81",
    //                 "route_path": "enroll_staff",
    //                 "alias_name": "Enroll Staff",
    //                 "name": "Enroll Staff",
    //                 "parentId": "64a3c42da5b49011b1702d73",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d83",
    //             "branchModuleId": "6669e4ec4934c4853ac35f0c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b1",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d83",
    //                 "route_path": "staff_attendance",
    //                 "alias_name": "Staff Attendance",
    //                 "name": "Staff Attendance",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d85",
    //             "branchModuleId": "6669e4ec4934c4853ac35f0d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b2",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d85",
    //                 "route_path": "give_daily_attendance",
    //                 "alias_name": "Daily Attendance",
    //                 "name": "Daily Attendance",
    //                 "parentId": "64a3c42da5b49011b1702d83",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d87",
    //             "branchModuleId": "6669e4ec4934c4853ac35f0e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b3",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d87",
    //                 "route_path": "daily_attendance_report",
    //                 "alias_name": "Daily Attendance Report",
    //                 "name": "Daily Attendance Report",
    //                 "parentId": "64a3c42da5b49011b1702d83",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d89",
    //             "branchModuleId": "6669e4ec4934c4853ac35f0f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b4",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d89",
    //                 "route_path": "my_attendance",
    //                 "alias_name": "My Attendance",
    //                 "name": "My Attendance",
    //                 "parentId": "64a3c42da5b49011b1702d83",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d8b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f12",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b5",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d8b",
    //                 "route_path": "staff_leave",
    //                 "alias_name": "Staff Leave",
    //                 "name": "Staff Leave",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d8d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f13",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b6",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d8d",
    //                 "route_path": "staff_apply_leave",
    //                 "alias_name": "Apply Leave",
    //                 "name": "Apply Leave",
    //                 "parentId": "64a3c42da5b49011b1702d8b",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d8f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f14",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b7",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d8f",
    //                 "route_path": "leave_approvals",
    //                 "alias_name": "Staff Leave Approval",
    //                 "name": "Staff Leave Approval",
    //                 "parentId": "6683d59aa1fd1f477a331fe4",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d93",
    //             "branchModuleId": "6669e4ec4934c4853ac35f16",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b8",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d93",
    //                 "route_path": "staff_approve_leaves",
    //                 "alias_name": "Leave Requests",
    //                 "name": "Leave Requests",
    //                 "parentId": "64a3c42da5b49011b1702d8b",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d95",
    //             "branchModuleId": "6669e4ec4934c4853ac35f17",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24b9",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d95",
    //                 "route_path": "approve_staff_special_leaves",
    //                 "alias_name": "Staff Special Leaves",
    //                 "name": "Staff Special Leaves",
    //                 "parentId": "64a3c42da5b49011b1702d8b",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d97",
    //             "branchModuleId": "6669e4ec4934c4853ac35f18",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24ba",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d97",
    //                 "route_path": "apply_leaves_for_staff",
    //                 "alias_name": "Apply Leaves For Staff",
    //                 "name": "Apply Leaves For Staff",
    //                 "parentId": "64a3c42da5b49011b1702d8b",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d9a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f19",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24bb",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d9a",
    //                 "route_path": "update_staff_monthly_leaves",
    //                 "alias_name": "Update Staff Monthly leaves",
    //                 "name": "Update Staff Monthly leaves",
    //                 "parentId": "64a3c42da5b49011b1702d8b",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702dbd",
    //             "branchModuleId": "6669e4ec4934c4853ac35f1a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24bc",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702dbd",
    //                 "route_path": "hr_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702dc2",
    //             "branchModuleId": "6669e4ec4934c4853ac35f1b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24bd",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702dc2",
    //                 "route_path": "staff_attendance_report",
    //                 "alias_name": "Staff Attendance Report",
    //                 "name": "Staff Attendance Report",
    //                 "parentId": "64a3c42da5b49011b1702dbd",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702dc5",
    //             "branchModuleId": "6669e4ec4934c4853ac35f1c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24be",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702dc5",
    //                 "route_path": "staff_details_report",
    //                 "alias_name": "Staff Details Report",
    //                 "name": "Staff Details Report",
    //                 "parentId": "64a3c42da5b49011b1702dbd",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702dca",
    //             "branchModuleId": "6669e4ec4934c4853ac35f1d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24bf",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702dca",
    //                 "route_path": "staff_leaves_report",
    //                 "alias_name": "Staff Leaves Report",
    //                 "name": "Staff Leaves Report",
    //                 "parentId": "64a3c42da5b49011b1702dbd",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702dd1",
    //             "branchModuleId": "6669e4ec4934c4853ac35f1e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c0",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702dd1",
    //                 "route_path": "inactive_staff_details",
    //                 "alias_name": "Inactive Staff Details",
    //                 "name": "Inactive Staff Details",
    //                 "parentId": "64a3c42da5b49011b1702dbd",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702de9",
    //             "branchModuleId": "6669e4ec4934c4853ac35f1f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c1",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702de9",
    //                 "route_path": "hr_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702dfb",
    //             "branchModuleId": "6669e4ec4934c4853ac35f20",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c2",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702dfb",
    //                 "route_path": "create_staff_sequence_no",
    //                 "alias_name": "Staff Enrollment Sequence Number Settings",
    //                 "name": "Staff Enrollment Sequence Number Settings",
    //                 "parentId": "64a3c42ea5b49011b1702de9",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e03",
    //             "branchModuleId": "6669e4ec4934c4853ac35f21",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c3",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e03",
    //                 "route_path": "shifts",
    //                 "alias_name": "Shifts",
    //                 "name": "Shifts",
    //                 "parentId": "64a3c42ea5b49011b1702de9",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e07",
    //             "branchModuleId": "6669e4ec4934c4853ac35f23",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c4",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e07",
    //                 "route_path": "leave_management",
    //                 "alias_name": "Leave Management",
    //                 "name": "Leave Management",
    //                 "parentId": "64a3c42ea5b49011b1702de9",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e09",
    //             "branchModuleId": "6669e4ec4934c4853ac35f25",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c5",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e09",
    //                 "route_path": "departments",
    //                 "alias_name": "Departments",
    //                 "name": "Departments",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e0c",
    //             "branchModuleId": "6669e4ec4934c4853ac35f26",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c6",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e0c",
    //                 "route_path": "create_department",
    //                 "alias_name": "Create/View Departments",
    //                 "name": "Create/View Departments",
    //                 "parentId": "64a3c42ea5b49011b1702e09",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e0e",
    //             "branchModuleId": "6669e4ec4934c4853ac35f27",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c7",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e0e",
    //                 "route_path": "designations",
    //                 "alias_name": "Designations",
    //                 "name": "Designations",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e10",
    //             "branchModuleId": "6669e4ec4934c4853ac35f28",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24c8",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e10",
    //                 "route_path": "create_designation",
    //                 "alias_name": "Create/View Designations",
    //                 "name": "Create/View Designations",
    //                 "parentId": "64a3c42ea5b49011b1702e0e",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e14",
    //             "branchModuleId": "6669e4ec4934c4853ac35f2f",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a15",
    //                         "name": "communication_sms_overview",
    //                         "label": "SMS Overview",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24ca"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a06",
    //                         "name": "communication_sms_status",
    //                         "label": "SMS Status",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24cb"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a14",
    //                         "name": "communication_event_calender",
    //                         "label": "Event Calender",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24cc"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a09",
    //                         "name": "communication_schedule_alerts",
    //                         "label": "Schedule Alerts",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24cd"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a2f",
    //                         "name": "communication_recharge_history",
    //                         "label": "Recharge History",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24ce"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a32",
    //                         "name": "communication_sms_details",
    //                         "label": "SMS Details",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24cf"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a67",
    //                         "name": "communication_sms",
    //                         "label": "SMS",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24d0"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a6a",
    //                         "name": "communication_message_approval",
    //                         "label": "Message Approval",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24d1"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a6d",
    //                         "name": "communication_announcement_approval",
    //                         "label": "Announcement Approvals",
    //                         "route_path": "communications"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24d2"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d24c9",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e14",
    //                 "route_path": "communications",
    //                 "alias_name": "Communications",
    //                 "name": "Communications",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e17",
    //             "branchModuleId": "6669e4ec4934c4853ac35f30",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24d3",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e17",
    //                 "route_path": "sms",
    //                 "alias_name": "SMS",
    //                 "name": "SMS",
    //                 "parentId": "64a3c42ea5b49011b1702e14",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e19",
    //             "branchModuleId": "6669e4ec4934c4853ac35f31",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24d4",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e19",
    //                 "route_path": "send_fee_due_sms",
    //                 "alias_name": "Send Fee Due SMS",
    //                 "name": "Send Fee Due SMS",
    //                 "parentId": "64a3c42ea5b49011b1702e17",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e1b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f32",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24d5",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e1b",
    //                 "route_path": "send_sms",
    //                 "alias_name": "Send SMS",
    //                 "name": "Send SMS",
    //                 "parentId": "64a3c42ea5b49011b1702e17",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e20",
    //             "branchModuleId": "6669e4ec4934c4853ac35f34",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24d6",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e20",
    //                 "route_path": "communications_approval",
    //                 "alias_name": "Approvals",
    //                 "name": "Approvals",
    //                 "parentId": "64a3c42ea5b49011b1702e14",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e22",
    //             "branchModuleId": "6669e4ec4934c4853ac35f35",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24d7",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e22",
    //                 "route_path": "approve_announcements",
    //                 "alias_name": "SMS Approvals",
    //                 "name": "SMS Approvals",
    //                 "parentId": "64a3c42ea5b49011b1702e20",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e24",
    //             "branchModuleId": "6669e4ec4934c4853ac35f36",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24d8",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e24",
    //                 "route_path": "event_calender",
    //                 "alias_name": "Event Calender",
    //                 "name": "Event Calender",
    //                 "parentId": "64a3c42ea5b49011b1702e14",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e26",
    //             "branchModuleId": "6669e4ec4934c4853ac35f37",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24d9",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e26",
    //                 "route_path": "create_view_event_type",
    //                 "alias_name": "Event Types",
    //                 "name": "Event Types",
    //                 "parentId": "64a3c42ea5b49011b1702e24",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e28",
    //             "branchModuleId": "6669e4ec4934c4853ac35f38",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24da",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e28",
    //                 "route_path": "create_view_event",
    //                 "alias_name": "Event Creation",
    //                 "name": "Event Creation",
    //                 "parentId": "64a3c42ea5b49011b1702e24",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e2a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f39",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24db",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e2a",
    //                 "route_path": "communication_announcements",
    //                 "alias_name": "Announcements",
    //                 "name": "Announcements",
    //                 "parentId": "64a3c42ea5b49011b1702e14",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e2d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f3a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24dc",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e2d",
    //                 "route_path": "announcements",
    //                 "alias_name": "Create Announcements",
    //                 "name": "Create Announcements",
    //                 "parentId": "64a3c42ea5b49011b1702e2a",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e2f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f3b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24dd",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e2f",
    //                 "route_path": "announcement_approvals",
    //                 "alias_name": "Announcement Approvals",
    //                 "name": "Announcement Approvals",
    //                 "parentId": "64a3c42ea5b49011b1702e20",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e31",
    //             "branchModuleId": "6669e4ec4934c4853ac35f40",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24de",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e31",
    //                 "route_path": "communication_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42ea5b49011b1702e14",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e33",
    //             "branchModuleId": "6669e4ec4934c4853ac35f41",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24df",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e33",
    //                 "route_path": "template_settings",
    //                 "alias_name": "Communication Templates",
    //                 "name": "Communication Templates",
    //                 "parentId": "64a3c42ea5b49011b1702e31",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e35",
    //             "branchModuleId": "6669e4ec4934c4853ac35f42",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24e0",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e35",
    //                 "route_path": "approval_settings",
    //                 "alias_name": "SMS Approval Settings",
    //                 "name": "SMS Approval Settings",
    //                 "parentId": "64a3c42ea5b49011b1702e31",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e37",
    //             "branchModuleId": "6669e4ec4934c4853ac35f43",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24e1",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e37",
    //                 "route_path": "dlt_template_settings",
    //                 "alias_name": "DLT Template",
    //                 "name": "DLT Template",
    //                 "parentId": "64a3c42ea5b49011b1702e31",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e41",
    //             "branchModuleId": "6669e4ec4934c4853ac35f44",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24e2",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e41",
    //                 "route_path": "announcement_settings",
    //                 "alias_name": "Announcement Setup",
    //                 "name": "Announcement Setup",
    //                 "parentId": "64a3c42ea5b49011b1702e2a",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e43",
    //             "branchModuleId": "6669e4ec4934c4853ac35f45",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24e3",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e43",
    //                 "route_path": "credentials",
    //                 "alias_name": "Credentials",
    //                 "name": "Credentials",
    //                 "parentId": "64a3c42ea5b49011b1702e31",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e45",
    //             "branchModuleId": "6669e4ec4934c4853ac35f46",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24e4",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e45",
    //                 "route_path": "password_generation",
    //                 "alias_name": "Password Generation",
    //                 "name": "Password Generation",
    //                 "parentId": "64a3c42ea5b49011b1702e31",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e47",
    //             "branchModuleId": "6669e4ec4934c4853ac35f47",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a76",
    //                         "name": "Attendance_overview",
    //                         "label": "Attendance Overview",
    //                         "route_path": "Attendance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24e6"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a7e",
    //                         "name": "Attendance_stats",
    //                         "label": "Attendance Stats",
    //                         "route_path": "Attendance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24e7"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a7b",
    //                         "name": "Attendance_daily_attendance",
    //                         "label": "Daily Attendance",
    //                         "route_path": "Attendance"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24e8"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d24e5",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e47",
    //                 "route_path": "Attendance",
    //                 "alias_name": "Attendance",
    //                 "name": "Attendance",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e4c",
    //             "branchModuleId": "6669e4ec4934c4853ac35f48",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24e9",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e4c",
    //                 "route_path": "daily_attendance",
    //                 "alias_name": "Daily Attendance",
    //                 "name": "Daily Attendance",
    //                 "parentId": "64a3c42ea5b49011b1702e47",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e4f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f49",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24ea",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e4f",
    //                 "route_path": "view_attendance",
    //                 "alias_name": "View Attendance",
    //                 "name": "View Attendance",
    //                 "parentId": "64a3c42ea5b49011b1702e4c",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e51",
    //             "branchModuleId": "6669e4ec4934c4853ac35f4d",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a81",
    //                         "name": "certificates_report",
    //                         "label": "Certificate Report",
    //                         "route_path": "certificates"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24ec"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a87",
    //                         "name": "certificates_issued_certificate",
    //                         "label": "Issued Certificate",
    //                         "route_path": "certificates"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24ed"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a84",
    //                         "name": "certificates_approvals",
    //                         "label": "Certificate Approvals",
    //                         "route_path": "certificates"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24ee"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d24eb",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e51",
    //                 "route_path": "certificates",
    //                 "alias_name": "Certificates",
    //                 "name": "Certificates",
    //                 "route": false,
    //                 "sequenceNumber": 8,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e53",
    //             "branchModuleId": "6669e4ec4934c4853ac35f4e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24ef",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e53",
    //                 "route_path": "student_certificate",
    //                 "alias_name": "Student Certificates",
    //                 "name": "Student Certificates",
    //                 "parentId": "64a3c42ea5b49011b1702e51",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e55",
    //             "branchModuleId": "6669e4ec4934c4853ac35f4f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24f0",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e55",
    //                 "route_path": "issue",
    //                 "alias_name": "Issue Certificate",
    //                 "name": "Issue Certificate",
    //                 "parentId": "64a3c42ea5b49011b1702e53",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e57",
    //             "branchModuleId": "6669e4ec4934c4853ac35f50",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24f1",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e57",
    //                 "route_path": "reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "64a3c42ea5b49011b1702e53",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e59",
    //             "branchModuleId": "6669e4ec4934c4853ac35f57",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24f2",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e59",
    //                 "route_path": "certificate_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42ea5b49011b1702e51",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e5b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f58",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24f3",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e5b",
    //                 "route_path": "certificate_sequence_number",
    //                 "alias_name": "Certificate Sequence Number Settings",
    //                 "name": "Certificate Sequence Number Settings",
    //                 "parentId": "64a3c42ea5b49011b1702e59",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e5d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f5a",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a8a",
    //                         "name": "students_overview",
    //                         "label": "Student Overview",
    //                         "route_path": "student_info"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24f5"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a8d",
    //                         "name": "students_shuffle",
    //                         "label": "Student Shuffle",
    //                         "route_path": "student_info"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24f6"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a90",
    //                         "name": "students_promotion",
    //                         "label": "Student Promotion",
    //                         "route_path": "student_info"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24f7"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a93",
    //                         "name": "students_transfer",
    //                         "label": "Transfered Student",
    //                         "route_path": "student_info"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24f8"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65bb3257a1fd1f477a0a7b99",
    //                         "name": "student_strength",
    //                         "label": "Student Strength",
    //                         "route_path": "student_info"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24f9"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65bb3257a1fd1f477a0a7b92",
    //                         "name": "student_birthday",
    //                         "label": "Student Birthday",
    //                         "route_path": "student_info"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24fa"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "66027c29a1fd1f477a0b8f55",
    //                         "name": "login_status",
    //                         "label": "Login Status",
    //                         "route_path": "student_info"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d24fb"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d24f4",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e5d",
    //                 "route_path": "student_info",
    //                 "alias_name": "Student Info",
    //                 "name": "Student Info",
    //                 "route": false,
    //                 "sequenceNumber": 9,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e5f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f5b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24fc",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e5f",
    //                 "route_path": "student_information",
    //                 "alias_name": "Student Information",
    //                 "name": "Student Information",
    //                 "parentId": "64a3c42ea5b49011b1702e5d",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e61",
    //             "branchModuleId": "6669e4ec4934c4853ac35f5c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24fd",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e61",
    //                 "route_path": "student_details",
    //                 "alias_name": "Student Details",
    //                 "name": "Student Details",
    //                 "parentId": "64a3c42ea5b49011b1702e5f",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ea5b49011b1702e63",
    //             "branchModuleId": "6669e4ec4934c4853ac35f5d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24fe",
    //             "module": {
    //                 "_id": "64a3c42ea5b49011b1702e63",
    //                 "route_path": "student_info_updation",
    //                 "alias_name": "Student Information Updation",
    //                 "name": "Student Information Updation",
    //                 "parentId": "64a3c42ea5b49011b1702e5f",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e65",
    //             "branchModuleId": "6669e4ec4934c4853ac35f62",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d24ff",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e65",
    //                 "route_path": "student_reports",
    //                 "alias_name": "Student Reports",
    //                 "name": "Student Reports",
    //                 "parentId": "6662e100a1fd1f477a95b08e",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e68",
    //             "branchModuleId": "6669e4ec4934c4853ac35f5f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2500",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e68",
    //                 "route_path": "shuffles",
    //                 "alias_name": "Shuffle Student",
    //                 "name": "Shuffle Student",
    //                 "parentId": "64a3c42ea5b49011b1702e5f",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e6a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f5e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2501",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e6a",
    //                 "route_path": "promotions",
    //                 "alias_name": "Promote Student",
    //                 "name": "Promote Student",
    //                 "parentId": "64a3c42ea5b49011b1702e5f",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e6d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f63",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2502",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e6d",
    //                 "route_path": "active_students",
    //                 "alias_name": "Active Student",
    //                 "name": "Active Student",
    //                 "parentId": "6662e100a1fd1f477a95b08e",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e6f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f64",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a96",
    //                         "name": "academics_time_table",
    //                         "label": "Time Table",
    //                         "route_path": "academics"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2504"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13a99",
    //                         "name": "academics_subject_assign",
    //                         "label": "Subject Assign",
    //                         "route_path": "academics"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2505"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13ac0",
    //                         "name": "academics_subject_diary",
    //                         "label": "Subject Diary",
    //                         "route_path": "academics"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2506"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78a4da1fd1f477aa13ac0",
    //                         "name": "academics_subject_diary",
    //                         "label": "Subject Diary",
    //                         "route_path": "academics"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2507"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d2503",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e6f",
    //                 "route_path": "academics",
    //                 "alias_name": "Academics",
    //                 "name": "Academics",
    //                 "route": false,
    //                 "sequenceNumber": 10,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e71",
    //             "branchModuleId": "6669e4ec4934c4853ac35f65",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2508",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e71",
    //                 "route_path": "class_management",
    //                 "alias_name": "Class Management",
    //                 "name": "Class Management",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e73",
    //             "branchModuleId": "6669e4ec4934c4853ac35f66",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2509",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e73",
    //                 "route_path": "teacher_management",
    //                 "alias_name": "Teacher Management",
    //                 "name": "Teacher Management",
    //                 "parentId": "64a3c42fa5b49011b1702e71",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e75",
    //             "branchModuleId": "6669e4ec4934c4853ac35f67",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d250a",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e75",
    //                 "route_path": "timetable",
    //                 "alias_name": "Time Table",
    //                 "name": "Time Table",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e78",
    //             "branchModuleId": "6669e4ec4934c4853ac35f68",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d250b",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e78",
    //                 "route_path": "view_timetable",
    //                 "alias_name": "Create/View Time Table",
    //                 "name": "Create/View Time Table",
    //                 "parentId": "64a3c42fa5b49011b1702e75",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e7a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f69",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d250c",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e7a",
    //                 "route_path": "dairy",
    //                 "alias_name": "Diary",
    //                 "name": "Diary",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e7d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f6a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d250d",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e7d",
    //                 "route_path": "student_diary",
    //                 "alias_name": "Subject Diary",
    //                 "name": "Subject Diary",
    //                 "parentId": "64a3c42fa5b49011b1702e7a",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e81",
    //             "branchModuleId": "6669e4ec4934c4853ac35f6e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d250e",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e81",
    //                 "route_path": "vehicle",
    //                 "alias_name": "Transport Management",
    //                 "name": "Transport Management",
    //                 "parentId": "6577de82a1fd1f477ab6cc25",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42fa5b49011b1702e83",
    //             "branchModuleId": "6669e4ec4934c4853ac35f6f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d250f",
    //             "module": {
    //                 "_id": "64a3c42fa5b49011b1702e83",
    //                 "route_path": "vehicle_details",
    //                 "alias_name": "Vehicle Details",
    //                 "name": "Vehicle Details",
    //                 "parentId": "64a3c42fa5b49011b1702e81",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a50ea6a5b49011b191e3b0",
    //             "branchModuleId": "6669e4ec4934c4853ac35f6b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2510",
    //             "module": {
    //                 "_id": "64a50ea6a5b49011b191e3b0",
    //                 "route_path": "academic_approvals",
    //                 "alias_name": "Approvals",
    //                 "name": "Approvals",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a50ea6a5b49011b191e3b2",
    //             "branchModuleId": "6669e4ec4934c4853ac35f6c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2511",
    //             "module": {
    //                 "_id": "64a50ea6a5b49011b191e3b2",
    //                 "route_path": "diary_approvals",
    //                 "alias_name": "Diary Approvals",
    //                 "name": "Diary Approvals",
    //                 "parentId": "64a50ea6a5b49011b191e3b0",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a7bc74a5b49011b1d7eeb1",
    //             "branchModuleId": "6669e4ec4934c4853ac35f29",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2512",
    //             "module": {
    //                 "_id": "64a7bc74a5b49011b1d7eeb1",
    //                 "route_path": "staff_workloads",
    //                 "alias_name": "Staff Workload",
    //                 "name": "Staff Workload",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 8,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64a7bc74a5b49011b1d7eeb3",
    //             "branchModuleId": "6669e4ec4934c4853ac35f2a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2513",
    //             "module": {
    //                 "_id": "64a7bc74a5b49011b1d7eeb3",
    //                 "route_path": "allocate_workload",
    //                 "alias_name": "Allocate Workload",
    //                 "name": "Allocate Workload",
    //                 "parentId": "64a7bc74a5b49011b1d7eeb1",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a7bc74a5b49011b1d7eeb5",
    //             "branchModuleId": "6669e4ec4934c4853ac35f2b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2514",
    //             "module": {
    //                 "_id": "64a7bc74a5b49011b1d7eeb5",
    //                 "route_path": "teacher_workload",
    //                 "alias_name": "Teacher Workload",
    //                 "name": "Teacher Workload",
    //                 "parentId": "64a7bc74a5b49011b1d7eeb1",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64b0ec5ba5b49011b1c808b3",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2515",
    //             "module": {
    //                 "_id": "64b0ec5ba5b49011b1c808b3",
    //                 "route_path": "settings/branch_level_settings",
    //                 "alias_name": "Branch Level Settings",
    //                 "name": "Branch Level Settings",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 8,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64b0ec5ba5b49011b1c808b5",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2516",
    //             "module": {
    //                 "_id": "64b0ec5ba5b49011b1c808b5",
    //                 "route_path": "settings/org_information",
    //                 "alias_name": "Organization Information",
    //                 "name": "Organization Information",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 9,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64b7d7f8a5b49011b17cb332",
    //             "branchModuleId": "6669e4ec4934c4853ac35f15",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2517",
    //             "module": {
    //                 "_id": "64b7d7f8a5b49011b17cb332",
    //                 "route_path": "leave_history",
    //                 "alias_name": "Staff Leave History",
    //                 "name": "Staff Leave History",
    //                 "parentId": "64a3c42da5b49011b1702d8b",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64c09e6ea5b49011b16b6130",
    //             "branchModuleId": "6669e4ec4934c4853ac35f70",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2518",
    //             "module": {
    //                 "_id": "64c09e6ea5b49011b16b6130",
    //                 "route_path": "vehicle_routes",
    //                 "alias_name": "Vehicle Routes",
    //                 "name": "Vehicle Routes",
    //                 "parentId": "64a3c42fa5b49011b1702e81",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64cb56f5a5b49011b18bb133",
    //             "branchModuleId": "6669e4ec4934c4853ac35f0b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2519",
    //             "module": {
    //                 "_id": "64cb56f5a5b49011b18bb133",
    //                 "route_path": "staff_bulkupload",
    //                 "alias_name": "Staff Bulk Enroll",
    //                 "name": "Staff Bulk Enroll",
    //                 "parentId": "64a3c42da5b49011b1702d73",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64cb56f7a5b49011b18bb1d9",
    //             "branchModuleId": "6669e4ec4934c4853ac35f73",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d251a",
    //             "module": {
    //                 "_id": "64cb56f7a5b49011b18bb1d9",
    //                 "route_path": "route_fee_creation",
    //                 "alias_name": "Route Fee Creation",
    //                 "name": "Route Fee Creation",
    //                 "parentId": "64a3c42fa5b49011b1702e81",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64d4560da5b49011b1769c24",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d251b",
    //             "module": {
    //                 "_id": "64d4560da5b49011b1769c24",
    //                 "route_path": "settings/schedule_jobs",
    //                 "alias_name": "Schedule Jobs",
    //                 "name": "Schedule Jobs",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 10,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64daebbda5b49011b1433837",
    //             "branchModuleId": "6669e4ec4934c4853ac35edb",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d251c",
    //             "module": {
    //                 "_id": "64daebbda5b49011b1433837",
    //                 "route_path": "fee_type_report",
    //                 "alias_name": "Fee Type Report",
    //                 "name": "Fee Type Report",
    //                 "parentId": "64a3c42ca5b49011b1702d32",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64daebc0a5b49011b1433924",
    //             "branchModuleId": "6669e4ec4934c4853ac35f74",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d251d",
    //             "module": {
    //                 "_id": "64daebc0a5b49011b1433924",
    //                 "route_path": "assign_routesto_student",
    //                 "alias_name": "Student Route Mapping",
    //                 "name": "Student Route Mapping",
    //                 "parentId": "64a3c42fa5b49011b1702e81",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64ec1ba3a5b49011b12b96f3",
    //             "branchModuleId": "6669e4ec4934c4853ac35f33",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d251e",
    //             "module": {
    //                 "_id": "64ec1ba3a5b49011b12b96f3",
    //                 "route_path": "sent_sms",
    //                 "alias_name": "Sent SMS Report",
    //                 "name": "Sent SMS Report",
    //                 "parentId": "66053845a1fd1f477a5a3c2f",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64ec1ba4a5b49011b12b9731",
    //             "branchModuleId": "6669e4ec4934c4853ac35f7a",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a38",
    //                         "name": "expense_payment_mode",
    //                         "label": "Payment Mode",
    //                         "route_path": "expense_management"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2520"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a35",
    //                         "name": "expense_deposits",
    //                         "label": "Deposits",
    //                         "route_path": "expense_management"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2521"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a3b",
    //                         "name": "expense_expenditure",
    //                         "label": "Expenditure",
    //                         "route_path": "expense_management"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2522"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b781b4a1fd1f477aa01a3e",
    //                         "name": "expense_income",
    //                         "label": "Income",
    //                         "route_path": "expense_management"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2523"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d251f",
    //             "module": {
    //                 "_id": "64ec1ba4a5b49011b12b9731",
    //                 "route_path": "expense_management",
    //                 "alias_name": "Expense Management",
    //                 "name": "Expense Management",
    //                 "route": false,
    //                 "sequenceNumber": 12,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "64ec1ba4a5b49011b12b9733",
    //             "branchModuleId": "6669e4ec4934c4853ac35f7b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2524",
    //             "module": {
    //                 "_id": "64ec1ba4a5b49011b12b9733",
    //                 "route_path": "expense_tracking",
    //                 "alias_name": "Expense Tracking",
    //                 "name": "Expense Tracking",
    //                 "parentId": "64ec1ba4a5b49011b12b9731",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64ec1ba4a5b49011b12b9735",
    //             "branchModuleId": "6669e4ec4934c4853ac35f7c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2525",
    //             "module": {
    //                 "_id": "64ec1ba4a5b49011b12b9735",
    //                 "route_path": "all_expenses",
    //                 "alias_name": "All Expenses",
    //                 "name": "All Expenses",
    //                 "parentId": "64ec1ba4a5b49011b12b9733",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64ec1ba4a5b49011b12b9737",
    //             "branchModuleId": "6669e4ec4934c4853ac35f82",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2526",
    //             "module": {
    //                 "_id": "64ec1ba4a5b49011b12b9737",
    //                 "route_path": "expense_categories",
    //                 "alias_name": "Expense Categories",
    //                 "name": "Expense Categories",
    //                 "parentId": "64f93ec4a5b49011b18af74b",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64ec1ba4a5b49011b12b9739",
    //             "branchModuleId": "6669e4ec4934c4853ac35f7d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2527",
    //             "module": {
    //                 "_id": "64ec1ba4a5b49011b12b9739",
    //                 "route_path": "ledger_book",
    //                 "alias_name": "Ledger Book",
    //                 "name": "Ledger Book",
    //                 "parentId": "64ec1ba4a5b49011b12b9733",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64ec1ba4a5b49011b12b973b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f7e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2528",
    //             "module": {
    //                 "_id": "64ec1ba4a5b49011b12b973b",
    //                 "route_path": "expense_transactions",
    //                 "alias_name": "Expense Transactions",
    //                 "name": "Expense Transactions",
    //                 "parentId": "64ec1ba4a5b49011b12b9733",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64f7e3d0a5b49011b1665b09",
    //             "branchModuleId": "6669e4ec4934c4853ac35f10",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2529",
    //             "module": {
    //                 "_id": "64f7e3d0a5b49011b1665b09",
    //                 "route_path": "manual_staff_attendance",
    //                 "alias_name": "Mark Staff Attendance",
    //                 "name": "Mark Staff Attendance",
    //                 "parentId": "64a3c42da5b49011b1702d83",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64f7e3d2a5b49011b1665ba1",
    //             "branchModuleId": "6669e4ec4934c4853ac35f87",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d252a",
    //             "module": {
    //                 "_id": "64f7e3d2a5b49011b1665ba1",
    //                 "route_path": "exam_structure",
    //                 "alias_name": "Exam Structure",
    //                 "name": "Exam Structure",
    //                 "parentId": "64f9e517a5b49011b19ce8d7",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64f7e3d2a5b49011b1665ba3",
    //             "branchModuleId": "6669e4ec4934c4853ac35f88",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d252b",
    //             "module": {
    //                 "_id": "64f7e3d2a5b49011b1665ba3",
    //                 "route_path": "sub_skills",
    //                 "alias_name": "Sub Skills",
    //                 "name": "Sub Skills",
    //                 "parentId": "64f9e517a5b49011b19ce8d7",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64f7e3d2a5b49011b1665ba6",
    //             "branchModuleId": "6669e4ec4934c4853ac35f89",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d252c",
    //             "module": {
    //                 "_id": "64f7e3d2a5b49011b1665ba6",
    //                 "route_path": "exam_rule_setup",
    //                 "alias_name": "Exam Rule Setup",
    //                 "name": "Exam Rule Setup",
    //                 "parentId": "64f9e517a5b49011b19ce8d7",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64f7e3d2a5b49011b1665baa",
    //             "branchModuleId": "6669e4ec4934c4853ac35f8a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d252d",
    //             "module": {
    //                 "_id": "64f7e3d2a5b49011b1665baa",
    //                 "route_path": "exam_schedule",
    //                 "alias_name": "Schedule Exam",
    //                 "name": "Schedule Exam",
    //                 "parentId": "64f9e517a5b49011b19ce8d7",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64f7e3d2a5b49011b1665bb1",
    //             "branchModuleId": "6669e4ec4934c4853ac35f8b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d252e",
    //             "module": {
    //                 "_id": "64f7e3d2a5b49011b1665bb1",
    //                 "route_path": "grade_groups",
    //                 "alias_name": "Grade Book",
    //                 "name": "Grade Book",
    //                 "parentId": "6503fc11a5b49011b1a67e67",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64f7e3d2a5b49011b1665bb3",
    //             "branchModuleId": "6669e4ec4934c4853ac35f8c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d252f",
    //             "module": {
    //                 "_id": "64f7e3d2a5b49011b1665bb3",
    //                 "route_path": "grade_group",
    //                 "alias_name": "Grade Groups",
    //                 "name": "Grade Groups",
    //                 "parentId": "64f7e3d2a5b49011b1665bb1",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64f93ec4a5b49011b18af74b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f81",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2530",
    //             "module": {
    //                 "_id": "64f93ec4a5b49011b18af74b",
    //                 "route_path": "expense_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64ec1ba4a5b49011b12b9731",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "64f9e517a5b49011b19ce8d7",
    //             "branchModuleId": "6669e4ec4934c4853ac35f86",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2531",
    //             "module": {
    //                 "_id": "64f9e517a5b49011b19ce8d7",
    //                 "route_path": "exams_management",
    //                 "alias_name": "Exams",
    //                 "name": "Exams",
    //                 "parentId": "6503fc11a5b49011b1a67e67",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6503df2fa5b49011b1a32e9e",
    //             "branchModuleId": "6669e4ec4934c4853ac35f8d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2532",
    //             "module": {
    //                 "_id": "6503df2fa5b49011b1a32e9e",
    //                 "route_path": "marks_allocation",
    //                 "alias_name": "Marks Allocation",
    //                 "name": "Marks Allocation",
    //                 "parentId": "64f7e3d2a5b49011b1665bb1",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6503df2fa5b49011b1a32ea0",
    //             "branchModuleId": "6669e4ec4934c4853ac35f8e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2533",
    //             "module": {
    //                 "_id": "6503df2fa5b49011b1a32ea0",
    //                 "route_path": "marks_approval",
    //                 "alias_name": "Marks Approval",
    //                 "name": "Marks Approval",
    //                 "parentId": "64f7e3d2a5b49011b1665bb1",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6503df2fa5b49011b1a32ea3",
    //             "branchModuleId": "6669e4ec4934c4853ac35f8f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2534",
    //             "module": {
    //                 "_id": "6503df2fa5b49011b1a32ea3",
    //                 "route_path": "report_card",
    //                 "alias_name": "Report Card",
    //                 "name": "Report Card",
    //                 "parentId": "64f7e3d2a5b49011b1665bb1",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6503df2fa5b49011b1a32ea5",
    //             "branchModuleId": "6669e4ec4934c4853ac35f90",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2535",
    //             "module": {
    //                 "_id": "6503df2fa5b49011b1a32ea5",
    //                 "route_path": "report_card_template",
    //                 "alias_name": "Report Card Template",
    //                 "name": "Report Card Template",
    //                 "parentId": "64f7e3d2a5b49011b1665bb1",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6503fc11a5b49011b1a67e67",
    //             "branchModuleId": "6669e4ec4934c4853ac35f85",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e34d",
    //                         "name": "exams_report_card_status",
    //                         "label": "Report Card Status",
    //                         "route_path": "exams"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2537"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e353",
    //                         "name": "exams_top_performing_students",
    //                         "label": "Top Performing Students",
    //                         "route_path": "exams"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2538"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e350",
    //                         "name": "exams_upcoming_scheduled_exam",
    //                         "label": "Upcoming Scheduled Exams",
    //                         "route_path": "exams"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2539"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e356",
    //                         "name": "exams_pass_percentage",
    //                         "label": "Exams Pass Percentage",
    //                         "route_path": "exams"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d253a"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e359",
    //                         "name": "exams_marks_approval_status",
    //                         "label": "Marks Approval Status",
    //                         "route_path": "exams"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d253b"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d2536",
    //             "module": {
    //                 "_id": "6503fc11a5b49011b1a67e67",
    //                 "route_path": "exams",
    //                 "alias_name": "Exams and Grade Book",
    //                 "name": "Exams and Grade Book",
    //                 "route": false,
    //                 "sequenceNumber": 13,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "650a7bf1a5b49011b1a3bce8",
    //             "branchModuleId": "6669e4ec4934c4853ac35f83",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d253c",
    //             "module": {
    //                 "_id": "650a7bf1a5b49011b1a3bce8",
    //                 "route_path": "expense_sequence_settings",
    //                 "alias_name": "Expense Voucher Settings",
    //                 "name": "Expense Voucher Settings",
    //                 "parentId": "64f93ec4a5b49011b18af74b",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a4c",
    //             "branchModuleId": "6669e4ec4934c4853ac35f91",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e35c",
    //                         "name": "inventory_item_sale_overview",
    //                         "label": "Item Sale Overview",
    //                         "route_path": "inventory"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d253e"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e35f",
    //                         "name": "inventory_item_sale_history",
    //                         "label": "Item Sale History",
    //                         "route_path": "inventory"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d253f"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e362",
    //                         "name": "inventory_return_exchange_approvals",
    //                         "label": "Return/Cancellation Approvals",
    //                         "route_path": "inventory"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2540"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e365",
    //                         "name": "inventory_store_details",
    //                         "label": "Store Details",
    //                         "route_path": "inventory"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2541"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d253d",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a4c",
    //                 "route_path": "inventory",
    //                 "alias_name": "Inventory",
    //                 "name": "Inventory",
    //                 "route": false,
    //                 "sequenceNumber": 14,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a4e",
    //             "branchModuleId": "6669e4ec4934c4853ac35f92",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2542",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a4e",
    //                 "route_path": "inventory_creation",
    //                 "alias_name": "Inventory Creation",
    //                 "name": "Inventory Creation",
    //                 "parentId": "65377d59a5b49011b1548a4c",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a58",
    //             "branchModuleId": "6669e4ec4934c4853ac35f93",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2543",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a58",
    //                 "route_path": "category_creation",
    //                 "alias_name": "Category Creation",
    //                 "name": "Category Creation",
    //                 "parentId": "65377d59a5b49011b1548a4e",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a5a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f94",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2544",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a5a",
    //                 "route_path": "item_creation",
    //                 "alias_name": "Item Creation",
    //                 "name": "Item Creation",
    //                 "parentId": "65377d59a5b49011b1548a4e",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a5e",
    //             "branchModuleId": "6669e4ec4934c4853ac35f95",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2545",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a5e",
    //                 "route_path": "stores",
    //                 "alias_name": "Stores",
    //                 "name": "Stores",
    //                 "parentId": "65377d59a5b49011b1548a4e",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a6c",
    //             "branchModuleId": "6669e4ec4934c4853ac35f9a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2546",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a6c",
    //                 "route_path": "kits",
    //                 "alias_name": "Kit",
    //                 "name": "Kit",
    //                 "parentId": "65377d59a5b49011b1548a6e",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a6e",
    //             "branchModuleId": "6669e4ec4934c4853ac35f96",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2547",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a6e",
    //                 "route_path": "stock_management",
    //                 "alias_name": "Stock Management",
    //                 "name": "Stock Management",
    //                 "parentId": "65377d59a5b49011b1548a4c",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65377d59a5b49011b1548a70",
    //             "branchModuleId": "6669e4ec4934c4853ac35f99",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2548",
    //             "module": {
    //                 "_id": "65377d59a5b49011b1548a70",
    //                 "route_path": "stock_addition",
    //                 "alias_name": "Stock Addition",
    //                 "name": "Stock Addition",
    //                 "parentId": "65377d59a5b49011b1548a6e",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "654344a6a5b49011b1950e0c",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2549",
    //             "module": {
    //                 "_id": "654344a6a5b49011b1950e0c",
    //                 "route_path": "dynamic_form",
    //                 "alias_name": "Dynamic Forms",
    //                 "name": "Dynamic Forms",
    //                 "parentId": "662101bca1fd1f477a619158",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65544150a5b49011b16387b2",
    //             "branchModuleId": "6669e4ec4934c4853ac35f4a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d254a",
    //             "module": {
    //                 "_id": "65544150a5b49011b16387b2",
    //                 "route_path": "attendance_summary",
    //                 "alias_name": "Attendance Summary",
    //                 "name": "Attendance Summary",
    //                 "parentId": "64a3c42ea5b49011b1702e4c",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6556e0e2a5b49011b1af51ea",
    //             "branchModuleId": "6669e4ec4934c4853ac35f11",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d254b",
    //             "module": {
    //                 "_id": "6556e0e2a5b49011b1af51ea",
    //                 "route_path": "staff_attendance_summary",
    //                 "alias_name": "Attendance Summary",
    //                 "name": "Attendance Summary",
    //                 "parentId": "64a3c42da5b49011b1702d83",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6566da6da1fd1f477ae1a5af",
    //             "branchModuleId": "6669e4ec4934c4853ac35f59",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d254c",
    //             "module": {
    //                 "_id": "6566da6da1fd1f477ae1a5af",
    //                 "route_path": "certificate_approval_settings",
    //                 "alias_name": "Certificate Approval Settings",
    //                 "name": "Certificate Approval Settings",
    //                 "parentId": "64a3c42ea5b49011b1702e59",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6566da6da1fd1f477ae1a5b1",
    //             "branchModuleId": "6669e4ec4934c4853ac35f54",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d254d",
    //             "module": {
    //                 "_id": "6566da6da1fd1f477ae1a5b1",
    //                 "route_path": "certificate_approvals",
    //                 "alias_name": "Approvals",
    //                 "name": "Approvals",
    //                 "parentId": "64a3c42ea5b49011b1702e51",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6566da6da1fd1f477ae1a5b3",
    //             "branchModuleId": "6669e4ec4934c4853ac35f55",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d254e",
    //             "module": {
    //                 "_id": "6566da6da1fd1f477ae1a5b3",
    //                 "route_path": "certificate_approval_requests",
    //                 "alias_name": "Student Certificate Approvals",
    //                 "name": "Student Certificate Approvals",
    //                 "parentId": "6566da6da1fd1f477ae1a5b1",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6577de82a1fd1f477ab6cc25",
    //             "branchModuleId": "6669e4ec4934c4853ac35f6d",
    //             "dashlets": [
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e344",
    //                         "name": "transport_management_student_overview",
    //                         "label": "Transport Student Overview",
    //                         "route_path": "transportmanagement"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2550"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e347",
    //                         "name": "transport_management_vehicle_overview",
    //                         "label": "Transport Vehicle Overview",
    //                         "route_path": "transportmanagement"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2551"
    //                 },
    //                 {
    //                     "dashlet": {
    //                         "_id": "65b78fc1a1fd1f477aa1e34a",
    //                         "name": "transport_management_route_details",
    //                         "label": "Transport Route Details",
    //                         "route_path": "transportmanagement"
    //                     },
    //                     "isActive": true,
    //                     "_id": "67ac57482f07d6984e3d2552"
    //                 }
    //             ],
    //             "_id": "67ac57482f07d6984e3d254f",
    //             "module": {
    //                 "_id": "6577de82a1fd1f477ab6cc25",
    //                 "route_path": "transportmanagement",
    //                 "alias_name": "Transport",
    //                 "name": "Transport",
    //                 "route": false,
    //                 "sequenceNumber": 11,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "65792ae6a1fd1f477adc839c",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2553",
    //             "module": {
    //                 "_id": "65792ae6a1fd1f477adc839c",
    //                 "route_path": "seating_management",
    //                 "alias_name": "Infra Management",
    //                 "name": "Infra Management",
    //                 "route": false,
    //                 "sequenceNumber": 15,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "65792ae6a1fd1f477adc839e",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2554",
    //             "module": {
    //                 "_id": "65792ae6a1fd1f477adc839e",
    //                 "route_path": "building",
    //                 "alias_name": "Building Details",
    //                 "name": "Building Details",
    //                 "parentId": "65792ae6a1fd1f477adc839c",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65792ae6a1fd1f477adc83a0",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2555",
    //             "module": {
    //                 "_id": "65792ae6a1fd1f477adc83a0",
    //                 "route_path": "Infrastructur_management",
    //                 "alias_name": "Add Building Details",
    //                 "name": "Add Building Details",
    //                 "parentId": "65792ae6a1fd1f477adc839e",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65792ae6a1fd1f477adc83a2",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2556",
    //             "module": {
    //                 "_id": "65792ae6a1fd1f477adc83a2",
    //                 "route_path": "room_management_general",
    //                 "alias_name": "Add Room Management General",
    //                 "name": "Add Room Management General",
    //                 "parentId": "65792ae6a1fd1f477adc839e",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65792ae6a1fd1f477adc83a4",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2557",
    //             "module": {
    //                 "_id": "65792ae6a1fd1f477adc83a4",
    //                 "route_path": "room_allocation_exams",
    //                 "alias_name": "Add Room Management Exams",
    //                 "name": "Add Room Management Exams",
    //                 "parentId": "65792ae6a1fd1f477adc839e",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "657fea8ba1fd1f477a96c445",
    //             "branchModuleId": "6669e4ec4934c4853ac35f9b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2558",
    //             "module": {
    //                 "_id": "657fea8ba1fd1f477a96c445",
    //                 "route_path": "item_sale_report",
    //                 "alias_name": "Item Sale Report",
    //                 "name": "Item Sale Report",
    //                 "parentId": "65377d59a5b49011b1548a6e",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "657fea8ba1fd1f477a96c447",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2559",
    //             "module": {
    //                 "_id": "657fea8ba1fd1f477a96c447",
    //                 "route_path": "inventory_approvals",
    //                 "alias_name": "Approvals",
    //                 "name": "Approvals",
    //                 "parentId": "65377d59a5b49011b1548a4c",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "658ac0c7a1fd1f477ac4e078",
    //             "branchModuleId": "6669e4ec4934c4853ac35f97",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d255a",
    //             "module": {
    //                 "_id": "658ac0c7a1fd1f477ac4e078",
    //                 "route_path": "item_sale",
    //                 "alias_name": "Item Sale",
    //                 "name": "Item Sale",
    //                 "parentId": "65377d59a5b49011b1548a6e",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "658d2226a1fd1f477a069365",
    //             "branchModuleId": "6669e4ec4934c4853ac35f09",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d255b",
    //             "module": {
    //                 "_id": "658d2226a1fd1f477a069365",
    //                 "route_path": "staff_updation",
    //                 "alias_name": "Staff Information Updation",
    //                 "name": "Staff Information Updation",
    //                 "parentId": "64a3c42da5b49011b1702d73",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65a21338a1fd1f477a49afb3",
    //             "branchModuleId": "6669e4ec4934c4853ac35f9c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d255c",
    //             "module": {
    //                 "_id": "65a21338a1fd1f477a49afb3",
    //                 "route_path": "inventory_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "65377d59a5b49011b1548a4c",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65a21338a1fd1f477a49afb5",
    //             "branchModuleId": "6669e4ec4934c4853ac35f9d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d255d",
    //             "module": {
    //                 "_id": "65a21338a1fd1f477a49afb5",
    //                 "route_path": "create_inventory_receipt_sequence",
    //                 "alias_name": "Inventory Receipt Number Settings",
    //                 "name": "Inventory Receipt Number Settings",
    //                 "parentId": "65a21338a1fd1f477a49afb3",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65aad3a9a1fd1f477a3d117d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f4c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d255e",
    //             "module": {
    //                 "_id": "65aad3a9a1fd1f477a3d117d",
    //                 "route_path": "attendance_report",
    //                 "alias_name": "Attendance Report",
    //                 "name": "Attendance Report",
    //                 "parentId": "65ab4f7ea1fd1f477a49c77a",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65ab4f7ea1fd1f477a49c77a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f4b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d255f",
    //             "module": {
    //                 "_id": "65ab4f7ea1fd1f477a49c77a",
    //                 "route_path": "attendance_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "64a3c42ea5b49011b1702e47",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65b8ca1ea1fd1f477ac4761d",
    //             "branchModuleId": "6669e4ec4934c4853ac35f98",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2560",
    //             "module": {
    //                 "_id": "65b8ca1ea1fd1f477ac4761d",
    //                 "route_path": "return_cancel_request",
    //                 "alias_name": "Return/Cancellation Requests",
    //                 "name": "Return/Cancellation Requests",
    //                 "parentId": "65377d59a5b49011b1548a6e",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65b8ca1ea1fd1f477ac47626",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2561",
    //             "module": {
    //                 "_id": "65b8ca1ea1fd1f477ac47626",
    //                 "route_path": "return_cancel_approvals",
    //                 "alias_name": "Return/Cancellation Approvals",
    //                 "name": "Return/Cancellation Approvals",
    //                 "parentId": "657fea8ba1fd1f477a96c447",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65ba1207a1fd1f477ae9c02a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f24",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2562",
    //             "module": {
    //                 "_id": "65ba1207a1fd1f477ae9c02a",
    //                 "route_path": "staff_holidays",
    //                 "alias_name": "Holidays",
    //                 "name": "Holidays",
    //                 "parentId": "64a3c42ea5b49011b1702de9",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c0f433a1fd1f477aafbf57",
    //             "branchModuleId": "6669e4ec4934c4853ac35ee4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2563",
    //             "module": {
    //                 "_id": "65c0f433a1fd1f477aafbf57",
    //                 "route_path": "fee_cancellation_settings",
    //                 "alias_name": "Cancellation Settings",
    //                 "name": "Cancellation Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395aad",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2564",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395aad",
    //                 "route_path": "visitor_management",
    //                 "alias_name": "Visitor Management",
    //                 "name": "Visitor Management",
    //                 "route": false,
    //                 "sequenceNumber": 16,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395aaf",
    //             "branchModuleId": "6669e4ec4934c4853ac35faa",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2565",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395aaf",
    //                 "route_path": "visitor_details_management",
    //                 "alias_name": "Visitor Management",
    //                 "name": "Visitor Management",
    //                 "parentId": "65c5b26ba1fd1f477a395aad",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395ab1",
    //             "branchModuleId": "6669e4ec4934c4853ac35fab",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2566",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395ab1",
    //                 "route_path": "visitor_details_setup",
    //                 "alias_name": "Visitor Details Setup",
    //                 "name": "Visitor Details Setup",
    //                 "parentId": "65c5b26ba1fd1f477a395aaf",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395ab3",
    //             "branchModuleId": "6669e4ec4934c4853ac35fac",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2567",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395ab3",
    //                 "route_path": "visitors_record",
    //                 "alias_name": "Visitors Record",
    //                 "name": "Visitors Record",
    //                 "parentId": "65c5b26ba1fd1f477a395aaf",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395ab5",
    //             "branchModuleId": "6669e4ec4934c4853ac35fad",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2568",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395ab5",
    //                 "route_path": "visitor_passes",
    //                 "alias_name": "Visitor Pass",
    //                 "name": "Visitor Pass",
    //                 "parentId": "65c5b26ba1fd1f477a395aad",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395ab7",
    //             "branchModuleId": "6669e4ec4934c4853ac35fae",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2569",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395ab7",
    //                 "route_path": "staff_pass",
    //                 "alias_name": "Staff Pass",
    //                 "name": "Staff Pass",
    //                 "parentId": "65c5b26ba1fd1f477a395ab5",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395ab9",
    //             "branchModuleId": "6669e4ec4934c4853ac35faf",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d256a",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395ab9",
    //                 "route_path": "student_pass",
    //                 "alias_name": "Student Pass",
    //                 "name": "Student Pass",
    //                 "parentId": "65c5b26ba1fd1f477a395ab5",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395abb",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d256b",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395abb",
    //                 "route_path": "visitor_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "65c5b26ba1fd1f477a395aad",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395abd",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d256c",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395abd",
    //                 "route_path": "visitors_report",
    //                 "alias_name": "Visitors Report",
    //                 "name": "Visitors Report",
    //                 "parentId": "65c5b26ba1fd1f477a395abb",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395abf",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d256d",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395abf",
    //                 "route_path": "visitor_approvals",
    //                 "alias_name": "Approvals",
    //                 "name": "Approvals",
    //                 "parentId": "65c5b26ba1fd1f477a395aad",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65c5b26ba1fd1f477a395ac1",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d256e",
    //             "module": {
    //                 "_id": "65c5b26ba1fd1f477a395ac1",
    //                 "route_path": "visitor_approval",
    //                 "alias_name": "Visitor Approval",
    //                 "name": "Visitor Approval",
    //                 "parentId": "65c5b26ba1fd1f477a395abf",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65c640e8a1fd1f477a4a299c",
    //             "branchModuleId": "6669e4ec4934c4853ac35f9e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d256f",
    //             "module": {
    //                 "_id": "65c640e8a1fd1f477a4a299c",
    //                 "route_path": "inventory_discount_settings",
    //                 "alias_name": "Inventory Discount Settings",
    //                 "name": "Inventory Discount Settings",
    //                 "parentId": "65a21338a1fd1f477a49afb3",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65cee1c2a1fd1f477a380ce9",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2570",
    //             "module": {
    //                 "_id": "65cee1c2a1fd1f477a380ce9",
    //                 "route_path": "visitor_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "65c5b26ba1fd1f477a395aad",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65cee1c2a1fd1f477a380ceb",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2571",
    //             "module": {
    //                 "_id": "65cee1c2a1fd1f477a380ceb",
    //                 "route_path": "visitor_approval_settings",
    //                 "alias_name": "Visitor Approval Settings",
    //                 "name": "Visitor Approval Settings",
    //                 "parentId": "65cee1c2a1fd1f477a380ce9",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65ceec57a1fd1f477a393d8a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f71",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2572",
    //             "module": {
    //                 "_id": "65ceec57a1fd1f477a393d8a",
    //                 "route_path": "trips",
    //                 "alias_name": "Trips",
    //                 "name": "Trips",
    //                 "parentId": "64a3c42fa5b49011b1702e81",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65d8b74fa1fd1f477a595e4e",
    //             "branchModuleId": "6669e4ec4934c4853ac35f22",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2573",
    //             "module": {
    //                 "_id": "65d8b74fa1fd1f477a595e4e",
    //                 "route_path": "weekly_offs",
    //                 "alias_name": "Weekly Offs",
    //                 "name": "Weekly Offs",
    //                 "parentId": "64a3c42ea5b49011b1702de9",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65ddab3aa1fd1f477aeab1ca",
    //             "branchModuleId": "6669e4ec4934c4853ac35f72",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2574",
    //             "module": {
    //                 "_id": "65ddab3aa1fd1f477aeab1ca",
    //                 "route_path": "vehicle_tracking",
    //                 "alias_name": "Vehicle Tracking",
    //                 "name": "Vehicle Tracking",
    //                 "parentId": "64a3c42fa5b49011b1702e81",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65ddab3aa1fd1f477aeab1ce",
    //             "branchModuleId": "6669e4ec4934c4853ac35f75",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2575",
    //             "module": {
    //                 "_id": "65ddab3aa1fd1f477aeab1ce",
    //                 "route_path": "transport_bulk_upload",
    //                 "alias_name": "Tranport Fee Bulk Upload",
    //                 "name": "Tranport Fee Bulk Upload",
    //                 "parentId": "64a3c42fa5b49011b1702e81",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65e153f3a1fd1f477a5929c5",
    //             "branchModuleId": "6669e4ec4934c4853ac35ed2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2576",
    //             "module": {
    //                 "_id": "65e153f3a1fd1f477a5929c5",
    //                 "route_path": "fee_follow_up",
    //                 "alias_name": "Fee Followup",
    //                 "name": "Fee Followup",
    //                 "parentId": "64a3c42ca5b49011b1702d1a",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65ef3735a1fd1f477aef8212",
    //             "branchModuleId": "6669e4ec4934c4853ac35f9f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2577",
    //             "module": {
    //                 "_id": "65ef3735a1fd1f477aef8212",
    //                 "route_path": "inventory_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "65377d59a5b49011b1548a4c",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "65ef3735a1fd1f477aef8214",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2578",
    //             "module": {
    //                 "_id": "65ef3735a1fd1f477aef8214",
    //                 "route_path": "inventory_classwise_report",
    //                 "alias_name": "Class Wise Item Sale Report",
    //                 "name": "Class Wise Item Sale Report",
    //                 "parentId": "65ef3735a1fd1f477aef8212",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65f134eba1fd1f477a2762ce",
    //             "branchModuleId": "6669e4ec4934c4853ac35ec9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2579",
    //             "module": {
    //                 "_id": "65f134eba1fd1f477a2762ce",
    //                 "route_path": "settings/undo_approval_settings",
    //                 "alias_name": "Undo Approval",
    //                 "name": "Undo Approval",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 11,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "65fbffd6a1fd1f477a591a1b",
    //             "branchModuleId": "6669e4ec4934c4853ac35fa1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d257a",
    //             "module": {
    //                 "_id": "65fbffd6a1fd1f477a591a1b",
    //                 "route_path": "inventory_purchase_report",
    //                 "alias_name": "Purchase Report",
    //                 "name": "Purchase Report",
    //                 "parentId": "65ef3735a1fd1f477aef8212",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66053845a1fd1f477a5a3c2f",
    //             "branchModuleId": "6669e4ec4934c4853ac35f3c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d257b",
    //             "module": {
    //                 "_id": "66053845a1fd1f477a5a3c2f",
    //                 "route_path": "communication_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "64a3c42ea5b49011b1702e14",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66053845a1fd1f477a5a3c35",
    //             "branchModuleId": "6669e4ec4934c4853ac35f3d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d257c",
    //             "module": {
    //                 "_id": "66053845a1fd1f477a5a3c35",
    //                 "route_path": "login_reports",
    //                 "alias_name": "Login Reports",
    //                 "name": "Login Reports",
    //                 "parentId": "66053845a1fd1f477a5a3c2f",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66053845a1fd1f477a5a3c37",
    //             "branchModuleId": "6669e4ec4934c4853ac35f3e",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d257d",
    //             "module": {
    //                 "_id": "66053845a1fd1f477a5a3c37",
    //                 "route_path": "announcement_reports",
    //                 "alias_name": "Announcement Reports",
    //                 "name": "Announcement Reports",
    //                 "parentId": "66053845a1fd1f477a5a3c2f",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66053845a1fd1f477a5a3c3a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f3f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d257e",
    //             "module": {
    //                 "_id": "66053845a1fd1f477a5a3c3a",
    //                 "route_path": "notification_reports",
    //                 "alias_name": "Notification Reports",
    //                 "name": "Notification Reports",
    //                 "parentId": "66053845a1fd1f477a5a3c2f",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "660a3867a1fd1f477ae08f8f",
    //             "branchModuleId": "6669e4ec4934c4853ac35edc",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d257f",
    //             "module": {
    //                 "_id": "660a3867a1fd1f477ae08f8f",
    //                 "route_path": "student_fee_statement",
    //                 "alias_name": "Student Fee Statement",
    //                 "name": "Student Fee Statement",
    //                 "parentId": "64a3c42ca5b49011b1702d32",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "660eb16da1fd1f477a61f041",
    //             "branchModuleId": "6669e4ec4934c4853ac35f60",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2580",
    //             "module": {
    //                 "_id": "660eb16da1fd1f477a61f041",
    //                 "route_path": "branch_shift",
    //                 "alias_name": "Branch Shifts",
    //                 "name": "Branch Shifts",
    //                 "parentId": "64a3c42ea5b49011b1702e5f",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6618a89ea1fd1f477a7aa09d",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2581",
    //             "module": {
    //                 "_id": "6618a89ea1fd1f477a7aa09d",
    //                 "route_path": "alumni_enrollment",
    //                 "alias_name": "Alumni Enrollment",
    //                 "name": "Alumni Enrollment",
    //                 "parentId": "64a3c42da5b49011b1702d56",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "661e2fe3a1fd1f477a12b2c2",
    //             "branchModuleId": "6669e4ec4934c4853ac35ed6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2582",
    //             "module": {
    //                 "_id": "661e2fe3a1fd1f477a12b2c2",
    //                 "route_path": "student_wise_due_report",
    //                 "alias_name": "Student Wise Due Report",
    //                 "name": "Student Wise Due Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1f",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "662100e0a1fd1f477a6174e6",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2583",
    //             "module": {
    //                 "_id": "662100e0a1fd1f477a6174e6",
    //                 "route_path": "admission_followups",
    //                 "alias_name": "Followups",
    //                 "name": "Followups",
    //                 "parentId": "64a3c42da5b49011b1702d54",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "662100e0a1fd1f477a6174e8",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2584",
    //             "module": {
    //                 "_id": "662100e0a1fd1f477a6174e8",
    //                 "route_path": "leads_followup",
    //                 "alias_name": "Leads Followup",
    //                 "name": "Leads Followup",
    //                 "parentId": "662100e0a1fd1f477a6174e6",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "662101bca1fd1f477a619155",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2585",
    //             "module": {
    //                 "_id": "662101bca1fd1f477a619155",
    //                 "route_path": "admission_bulk_uploads",
    //                 "alias_name": "Bulk Upload",
    //                 "name": "Bulk Upload",
    //                 "parentId": "64a3c42da5b49011b1702d54",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "662101bca1fd1f477a619158",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2586",
    //             "module": {
    //                 "_id": "662101bca1fd1f477a619158",
    //                 "route_path": "admission_web_forms",
    //                 "alias_name": "Web Forms",
    //                 "name": "Web Forms",
    //                 "parentId": "64a3c42da5b49011b1702d54",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "662134c3a1fd1f477a6782ac",
    //             "branchModuleId": "6669e4ec4934c4853ac35eec",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2587",
    //             "module": {
    //                 "_id": "662134c3a1fd1f477a6782ac",
    //                 "route_path": "leads",
    //                 "alias_name": "Leads",
    //                 "name": "Leads",
    //                 "parentId": "64a3c42da5b49011b1702d56",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6628fa7ba1fd1f477a401b99",
    //             "branchModuleId": "6669e4ec4934c4853ac35f76",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2588",
    //             "module": {
    //                 "_id": "6628fa7ba1fd1f477a401b99",
    //                 "route_path": "transport_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "6577de82a1fd1f477ab6cc25",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6628fa7ba1fd1f477a401b9b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f77",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2589",
    //             "module": {
    //                 "_id": "6628fa7ba1fd1f477a401b9b",
    //                 "route_path": "assigned_routes_report",
    //                 "alias_name": "Assigned Routes Report",
    //                 "name": "Assigned Routes Report",
    //                 "parentId": "6628fa7ba1fd1f477a401b99",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6629ef02a1fd1f477a5a1f4b",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d258a",
    //             "module": {
    //                 "_id": "6629ef02a1fd1f477a5a1f4b",
    //                 "route_path": "concerns_feedbacks",
    //                 "alias_name": "Concerns and Feedbacks",
    //                 "name": "Concerns and Feedbacks",
    //                 "route": false,
    //                 "sequenceNumber": 17,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "6629ef02a1fd1f477a5a1f4d",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d258b",
    //             "module": {
    //                 "_id": "6629ef02a1fd1f477a5a1f4d",
    //                 "route_path": "concerns_management",
    //                 "alias_name": "Concerns",
    //                 "name": "Concerns",
    //                 "parentId": "6629ef02a1fd1f477a5a1f4b",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6629ef02a1fd1f477a5a1f4f",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d258c",
    //             "module": {
    //                 "_id": "6629ef02a1fd1f477a5a1f4f",
    //                 "route_path": "concern_types",
    //                 "alias_name": "Concern Types",
    //                 "name": "Concern Types",
    //                 "parentId": "6629ef02a1fd1f477a5a1f4d",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "662b7bd7a1fd1f477a859f27",
    //             "branchModuleId": "6669e4ec4934c4853ac35fb9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d258d",
    //             "module": {
    //                 "_id": "662b7bd7a1fd1f477a859f27",
    //                 "route_path": "concern_form",
    //                 "alias_name": "Concern Form",
    //                 "name": "Concern Form",
    //                 "parentId": "6629ef02a1fd1f477a5a1f4d",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66339f5ca1fd1f477a651310",
    //             "branchModuleId": "6669e4ec4934c4853ac35f78",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d258e",
    //             "module": {
    //                 "_id": "66339f5ca1fd1f477a651310",
    //                 "route_path": "transport_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "6577de82a1fd1f477ab6cc25",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66339f5ca1fd1f477a651312",
    //             "branchModuleId": "6669e4ec4934c4853ac35f79",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d258f",
    //             "module": {
    //                 "_id": "66339f5ca1fd1f477a651312",
    //                 "route_path": "trip_notification_settings",
    //                 "alias_name": "Trip Notification Settings",
    //                 "name": "Trip Notification Settings",
    //                 "parentId": "66339f5ca1fd1f477a651310",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6639b93aa1fd1f477a0a0a5f",
    //             "branchModuleId": "6669e4ec4934c4853ac35eff",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2590",
    //             "module": {
    //                 "_id": "6639b93aa1fd1f477a0a0a5f",
    //                 "route_path": "leads_sequence_settings",
    //                 "alias_name": "Leads Code Settings",
    //                 "name": "Leads Code Settings",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6639b93aa1fd1f477a0a0a61",
    //             "branchModuleId": "6669e4ec4934c4853ac35f00",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2591",
    //             "module": {
    //                 "_id": "6639b93aa1fd1f477a0a0a61",
    //                 "route_path": "enquiry_sequence_settings",
    //                 "alias_name": "Enquiry Code Settings",
    //                 "name": "Enquiry Code Settings",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6644a791a1fd1f477a3fd343",
    //             "branchModuleId": "6669e4ec4934c4853ac35f51",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2592",
    //             "module": {
    //                 "_id": "6644a791a1fd1f477a3fd343",
    //                 "route_path": "staff_certificates",
    //                 "alias_name": "Staff Certificates",
    //                 "name": "Staff Certificates",
    //                 "parentId": "64a3c42ea5b49011b1702e51",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6644a791a1fd1f477a3fd345",
    //             "branchModuleId": "6669e4ec4934c4853ac35f52",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2593",
    //             "module": {
    //                 "_id": "6644a791a1fd1f477a3fd345",
    //                 "route_path": "staff_certificate_issue",
    //                 "alias_name": "Issue Certificate",
    //                 "name": "Issue Certificate",
    //                 "parentId": "6644a791a1fd1f477a3fd343",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6644a791a1fd1f477a3fd347",
    //             "branchModuleId": "6669e4ec4934c4853ac35f53",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2594",
    //             "module": {
    //                 "_id": "6644a791a1fd1f477a3fd347",
    //                 "route_path": "staff_certificate_report",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "6644a791a1fd1f477a3fd343",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6644a791a1fd1f477a3fd34b",
    //             "branchModuleId": "6669e4ec4934c4853ac35f56",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2595",
    //             "module": {
    //                 "_id": "6644a791a1fd1f477a3fd34b",
    //                 "route_path": "staff_certificate_approval_requests",
    //                 "alias_name": "Staff Certificate Approvals",
    //                 "name": "Staff Certificate Approvals",
    //                 "parentId": "6566da6da1fd1f477ae1a5b1",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "664757dba1fd1f477a8d13b6",
    //             "branchModuleId": "6669e4ec4934c4853ac35ecb",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2596",
    //             "module": {
    //                 "_id": "664757dba1fd1f477a8d13b6",
    //                 "route_path": "settings/approval_email_settings",
    //                 "alias_name": "Approval Email Settings",
    //                 "name": "Approval Email Settings",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 12,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "664c8ee0a1fd1f477a24d313",
    //             "branchModuleId": "6669e4ec4934c4853ac35f7f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2597",
    //             "module": {
    //                 "_id": "664c8ee0a1fd1f477a24d313",
    //                 "route_path": "expense_approvals",
    //                 "alias_name": "Approvals",
    //                 "name": "Approvals",
    //                 "parentId": "64ec1ba4a5b49011b12b9731",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "664c8ee0a1fd1f477a24d315",
    //             "branchModuleId": "6669e4ec4934c4853ac35f80",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2598",
    //             "module": {
    //                 "_id": "664c8ee0a1fd1f477a24d315",
    //                 "route_path": "expense_cancellation_approval",
    //                 "alias_name": "Expense Cancellation Approvals",
    //                 "name": "Expense Cancellation Approvals",
    //                 "parentId": "664c8ee0a1fd1f477a24d313",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "664c8ee1a1fd1f477a24d31a",
    //             "branchModuleId": "6669e4ec4934c4853ac35f84",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2599",
    //             "module": {
    //                 "_id": "664c8ee1a1fd1f477a24d31a",
    //                 "route_path": "expense_cancellation_settings",
    //                 "alias_name": "Expense Cancellation Settings",
    //                 "name": "Expense Cancellation Settings",
    //                 "parentId": "64f93ec4a5b49011b18af74b",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66506a3ca1fd1f477a9402a1",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d259a",
    //             "module": {
    //                 "_id": "66506a3ca1fd1f477a9402a1",
    //                 "route_path": "admission_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "64a3c42da5b49011b1702d54",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66506a3ca1fd1f477a9402a4",
    //             "branchModuleId": "6669e4ec4934c4853ac35ef9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d259b",
    //             "module": {
    //                 "_id": "66506a3ca1fd1f477a9402a4",
    //                 "route_path": "leads_report",
    //                 "alias_name": "Leads Report",
    //                 "name": "Leads Report",
    //                 "parentId": "66506a3ca1fd1f477a9402a1",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66506a3ca1fd1f477a9402a6",
    //             "branchModuleId": "6669e4ec4934c4853ac35efa",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d259c",
    //             "module": {
    //                 "_id": "66506a3ca1fd1f477a9402a6",
    //                 "route_path": "enquiry_report",
    //                 "alias_name": "Enquiry Report",
    //                 "name": "Enquiry Report",
    //                 "parentId": "66506a3ca1fd1f477a9402a1",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66506a3ca1fd1f477a9402a8",
    //             "branchModuleId": "6669e4ec4934c4853ac35efb",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d259d",
    //             "module": {
    //                 "_id": "66506a3ca1fd1f477a9402a8",
    //                 "route_path": "application_report",
    //                 "alias_name": "Application Report",
    //                 "name": "Application Report",
    //                 "parentId": "66506a3ca1fd1f477a9402a1",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "665742caa1fd1f477a50d37a",
    //             "branchModuleId": "6669e4ec4934c4853ac35eca",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d259e",
    //             "module": {
    //                 "_id": "665742caa1fd1f477a50d37a",
    //                 "route_path": "customform",
    //                 "alias_name": "Custom Form Settings",
    //                 "name": "Custom Form Settings",
    //                 "parentId": "64a3c42ca5b49011b1702cfa",
    //                 "route": false,
    //                 "sequenceNumber": 12,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6662e100a1fd1f477a95b08e",
    //             "branchModuleId": "6669e4ec4934c4853ac35f61",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d259f",
    //             "module": {
    //                 "_id": "6662e100a1fd1f477a95b08e",
    //                 "route_path": "student_info_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "64a3c42ea5b49011b1702e5d",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "666982bba1fd1f477a4feb55",
    //             "branchModuleId": "666fa6bfbe7f45e0f882ebd5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a0",
    //             "module": {
    //                 "_id": "666982bba1fd1f477a4feb55",
    //                 "route_path": "hr_payroll",
    //                 "alias_name": "Payroll Setup",
    //                 "name": "Payroll Setup",
    //                 "parentId": "666982e8a1fd1f477a4ff2ff",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "666982bba1fd1f477a4feb57",
    //             "branchModuleId": "666fa6bfbe7f45e0f882ebd6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a1",
    //             "module": {
    //                 "_id": "666982bba1fd1f477a4feb57",
    //                 "route_path": "payroll",
    //                 "alias_name": "Payroll",
    //                 "name": "Payroll",
    //                 "parentId": "666982bba1fd1f477a4feb55",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "666982e8a1fd1f477a4ff2ff",
    //             "branchModuleId": "666fa6bfbe7f45e0f882ebd4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a2",
    //             "module": {
    //                 "_id": "666982e8a1fd1f477a4ff2ff",
    //                 "route_path": "hr_pro",
    //                 "alias_name": "HR Payroll",
    //                 "name": "HR Payroll",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "667189f0a1fd1f477a3620ff",
    //             "branchModuleId": "6688214fa8b660caff1379f3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a3",
    //             "module": {
    //                 "_id": "667189f0a1fd1f477a3620ff",
    //                 "route_path": "general_diary",
    //                 "alias_name": "General Diary",
    //                 "name": "General Diary",
    //                 "parentId": "64a3c42fa5b49011b1702e7a",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66829b85a1fd1f477a106629",
    //             "branchModuleId": "6688214fa8b660caff1379f0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a4",
    //             "module": {
    //                 "_id": "66829b85a1fd1f477a106629",
    //                 "route_path": "staff_details",
    //                 "alias_name": "Staff Details",
    //                 "name": "Staff Details",
    //                 "parentId": "64a3c42da5b49011b1702d73",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66837f15a1fd1f477a2884c2",
    //             "branchModuleId": "6688214fa8b660caff1379f4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a5",
    //             "module": {
    //                 "_id": "66837f15a1fd1f477a2884c2",
    //                 "route_path": "academic_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66837f15a1fd1f477a2884c4",
    //             "branchModuleId": "6688214fa8b660caff1379f5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a6",
    //             "module": {
    //                 "_id": "66837f15a1fd1f477a2884c4",
    //                 "route_path": "diary_approval_settings",
    //                 "alias_name": "Diary Approval Settings",
    //                 "name": "Diary Approval Settings",
    //                 "parentId": "66837f15a1fd1f477a2884c2",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6683d59aa1fd1f477a331fe4",
    //             "branchModuleId": "6688214fa8b660caff1379f1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a7",
    //             "module": {
    //                 "_id": "6683d59aa1fd1f477a331fe4",
    //                 "route_path": "staff_approvals",
    //                 "alias_name": "Approvals",
    //                 "name": "Approvals",
    //                 "parentId": "64a3c42da5b49011b1702d71",
    //                 "route": false,
    //                 "sequenceNumber": 9,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6683d59aa1fd1f477a331fe6",
    //             "branchModuleId": "6688214fa8b660caff1379f2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a8",
    //             "module": {
    //                 "_id": "6683d59aa1fd1f477a331fe6",
    //                 "route_path": "staff_resignation_approval",
    //                 "alias_name": "Staff Resignation Approval",
    //                 "name": "Staff Resignation Approval",
    //                 "parentId": "6683d59aa1fd1f477a331fe4",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "668b9336a1fd1f477a07b425",
    //             "branchModuleId": "669ebb8326e0828d3c0917dd",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25a9",
    //             "module": {
    //                 "_id": "668b9336a1fd1f477a07b425",
    //                 "route_path": "fee_type_wise_transaction",
    //                 "alias_name": "Fee Type Wise Transactions",
    //                 "name": "Fee Type Wise Transactions",
    //                 "parentId": "64a3c42ca5b49011b1702d32",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6690fab9a1fd1f477aa143db",
    //             "branchModuleId": "66a06da80706a7b80da5554f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25aa",
    //             "module": {
    //                 "_id": "6690fab9a1fd1f477aa143db",
    //                 "route_path": "attendance_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "64a3c42ea5b49011b1702e47",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6690fab9a1fd1f477aa143df",
    //             "branchModuleId": "66a06da80706a7b80da55550",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ab",
    //             "module": {
    //                 "_id": "6690fab9a1fd1f477aa143df",
    //                 "route_path": "student_holidays",
    //                 "alias_name": "Holidays",
    //                 "name": "Holidays",
    //                 "parentId": "6690fab9a1fd1f477aa143db",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "669a6409a1fd1f477aaa21f6",
    //             "branchModuleId": "66a06da80706a7b80da55551",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ac",
    //             "module": {
    //                 "_id": "669a6409a1fd1f477aaa21f6",
    //                 "route_path": "inventory_studentwise_report",
    //                 "alias_name": "Student Wise Item Sale Report",
    //                 "name": "Student Wise Item Sale Report",
    //                 "parentId": "65ef3735a1fd1f477aef8212",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66a240a1a1fd1f477a848186",
    //             "branchModuleId": "66a29b00a1ff90f13e47cbc2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ad",
    //             "module": {
    //                 "_id": "66a240a1a1fd1f477a848186",
    //                 "route_path": "hostel_management",
    //                 "alias_name": "Hostel Management",
    //                 "name": "Hostel Management",
    //                 "route": false,
    //                 "sequenceNumber": 18,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "66a240a1a1fd1f477a848188",
    //             "branchModuleId": "66a29b00a1ff90f13e47cbc3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ae",
    //             "module": {
    //                 "_id": "66a240a1a1fd1f477a848188",
    //                 "route_path": "hostel_details",
    //                 "alias_name": "Hostel Setup",
    //                 "name": "Hostel Setup",
    //                 "parentId": "66a240a1a1fd1f477a848186",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66a240a1a1fd1f477a84818a",
    //             "branchModuleId": "66b1163f6b44ca3917748f36",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25af",
    //             "module": {
    //                 "_id": "66a240a1a1fd1f477a84818a",
    //                 "route_path": "hostel_creation",
    //                 "alias_name": "Hostel Creation",
    //                 "name": "Hostel Creation",
    //                 "parentId": "66a240a1a1fd1f477a848188",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66a240a1a1fd1f477a84818c",
    //             "branchModuleId": "66b1163f6b44ca3917748f37",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b0",
    //             "module": {
    //                 "_id": "66a240a1a1fd1f477a84818c",
    //                 "route_path": "building_details",
    //                 "alias_name": "Building Details",
    //                 "name": "Building Details",
    //                 "parentId": "66a240a1a1fd1f477a848188",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66a240a1a1fd1f477a84818e",
    //             "branchModuleId": "66b116486b44ca3917748f3d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b1",
    //             "module": {
    //                 "_id": "66a240a1a1fd1f477a84818e",
    //                 "route_path": "assign_hostels",
    //                 "alias_name": "Assign Hostels to Branch",
    //                 "name": "Assign Hostels to Branch",
    //                 "parentId": "66a240a1a1fd1f477a848188",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66a86648a1fd1f477a2dc30a",
    //             "branchModuleId": "66af50448aaeb9b7f32580f1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b2",
    //             "module": {
    //                 "_id": "66a86648a1fd1f477a2dc30a",
    //                 "route_path": "never_logged_reports",
    //                 "alias_name": "Never Logged Reports",
    //                 "name": "Never Logged Reports",
    //                 "parentId": "66053845a1fd1f477a5a3c2f",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66aa5073a1fd1f477a64a833",
    //             "branchModuleId": "66aa55f352383c08bbda09d8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b3",
    //             "module": {
    //                 "_id": "66aa5073a1fd1f477a64a833",
    //                 "route_path": "kitchen_inventory",
    //                 "alias_name": "Kitchen Inventory",
    //                 "name": "Kitchen Inventory",
    //                 "parentId": "66a240a1a1fd1f477a848186",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66aa5073a1fd1f477a64a835",
    //             "branchModuleId": "66aa55f352383c08bbda09d9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b4",
    //             "module": {
    //                 "_id": "66aa5073a1fd1f477a64a835",
    //                 "route_path": "kitchen_item_creation",
    //                 "alias_name": "Item Creation",
    //                 "name": "Item Creation",
    //                 "parentId": "66aa5073a1fd1f477a64a833",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66aa5073a1fd1f477a64a837",
    //             "branchModuleId": "66aa55f352383c08bbda09da",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b5",
    //             "module": {
    //                 "_id": "66aa5073a1fd1f477a64a837",
    //                 "route_path": "purchase_entry",
    //                 "alias_name": "Purchase Entry",
    //                 "name": "Purchase Entry",
    //                 "parentId": "66aa5073a1fd1f477a64a833",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66aa5073a1fd1f477a64a839",
    //             "branchModuleId": "66aa55f352383c08bbda09db",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b6",
    //             "module": {
    //                 "_id": "66aa5073a1fd1f477a64a839",
    //                 "route_path": "usage_entry",
    //                 "alias_name": "Usage Entry",
    //                 "name": "Usage Entry",
    //                 "parentId": "66aa5073a1fd1f477a64a833",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66aa513da1fd1f477a64c0da",
    //             "branchModuleId": "66b9ab97adecc31a0d57c191",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b7",
    //             "module": {
    //                 "_id": "66aa513da1fd1f477a64c0da",
    //                 "route_path": "room_management",
    //                 "alias_name": "Room Management",
    //                 "name": "Room Management",
    //                 "parentId": "66a240a1a1fd1f477a848188",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b37b682b78b2b7a0215c3c",
    //             "branchModuleId": "66b47519fa5534b1280b9417",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b8",
    //             "module": {
    //                 "_id": "66b37b682b78b2b7a0215c3c",
    //                 "route_path": "ptm",
    //                 "alias_name": "PTM",
    //                 "name": "PTM",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66b37b682b78b2b7a0215c3e",
    //             "branchModuleId": "66b47519fa5534b1280b9418",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25b9",
    //             "module": {
    //                 "_id": "66b37b682b78b2b7a0215c3e",
    //                 "route_path": "schedule_ptm",
    //                 "alias_name": "PTM Schedule",
    //                 "name": "PTM Schedule",
    //                 "parentId": "66b37b682b78b2b7a0215c3c",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b37b682b78b2b7a0215c40",
    //             "branchModuleId": "66b47519fa5534b1280b9419",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ba",
    //             "module": {
    //                 "_id": "66b37b682b78b2b7a0215c40",
    //                 "route_path": "schedule_ptm_report",
    //                 "alias_name": "PTM Schedule Report",
    //                 "name": "PTM Schedule Report",
    //                 "parentId": "66b37b682b78b2b7a0215c3c",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b37b692b78b2b7a0215ccb",
    //             "branchModuleId": "66b6764db27d8013d1424c3a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25bb",
    //             "module": {
    //                 "_id": "66b37b692b78b2b7a0215ccb",
    //                 "route_path": "exam_settings",
    //                 "alias_name": "Settings",
    //                 "name": "Settings",
    //                 "parentId": "6503fc11a5b49011b1a67e67",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66b37b692b78b2b7a0215ccd",
    //             "branchModuleId": "66b6764db27d8013d1424c3b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25bc",
    //             "module": {
    //                 "_id": "66b37b692b78b2b7a0215ccd",
    //                 "route_path": "hallticket_template",
    //                 "alias_name": "Hall Ticket Settings",
    //                 "name": "Hall Ticket Settings",
    //                 "parentId": "66b37b692b78b2b7a0215ccb",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b37b6a2b78b2b7a0215d1d",
    //             "branchModuleId": "66b3b345fa5534b1280b3fd3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25bd",
    //             "module": {
    //                 "_id": "66b37b6a2b78b2b7a0215d1d",
    //                 "route_path": "hostel_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "66a240a1a1fd1f477a848186",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66b37b6a2b78b2b7a0215d1f",
    //             "branchModuleId": "66b3b345fa5534b1280b3fd4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25be",
    //             "module": {
    //                 "_id": "66b37b6a2b78b2b7a0215d1f",
    //                 "route_path": "usage_report",
    //                 "alias_name": "Purchase & Usage Report",
    //                 "name": "Purchase & Usage Report",
    //                 "parentId": "66b37b6a2b78b2b7a0215d1d",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b61d552b78b2b7a06cd79b",
    //             "branchModuleId": "66b6764db27d8013d1424c36",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25bf",
    //             "module": {
    //                 "_id": "66b61d552b78b2b7a06cd79b",
    //                 "route_path": "activities",
    //                 "alias_name": "Activities",
    //                 "name": "Activities",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66b61d552b78b2b7a06cd79d",
    //             "branchModuleId": "66b6764db27d8013d1424c37",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c0",
    //             "module": {
    //                 "_id": "66b61d552b78b2b7a06cd79d",
    //                 "route_path": "activity",
    //                 "alias_name": "Activity Creation",
    //                 "name": "Activity Creation",
    //                 "parentId": "66b61d552b78b2b7a06cd79b",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b61d552b78b2b7a06cd7a1",
    //             "branchModuleId": "66b6764db27d8013d1424c38",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c1",
    //             "module": {
    //                 "_id": "66b61d552b78b2b7a06cd7a1",
    //                 "route_path": "activity_approvals",
    //                 "alias_name": "Activity Approvals",
    //                 "name": "Activity Approvals",
    //                 "parentId": "64a50ea6a5b49011b191e3b0",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b61d552b78b2b7a06cd7bd",
    //             "branchModuleId": "66b6764db27d8013d1424c39",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c2",
    //             "module": {
    //                 "_id": "66b61d552b78b2b7a06cd7bd",
    //                 "route_path": "activity_type_settings",
    //                 "alias_name": "Activity Settings",
    //                 "name": "Activity Settings",
    //                 "parentId": "66837f15a1fd1f477a2884c2",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b9f23b2b78b2b7a0d5db86",
    //             "branchModuleId": "66bb7711aba984c8b8620ae4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c3",
    //             "module": {
    //                 "_id": "66b9f23b2b78b2b7a0d5db86",
    //                 "route_path": "installment_wise_due_reports",
    //                 "alias_name": "Installment Wise Due Report",
    //                 "name": "Installment Wise Due Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1f",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66b9f23f2b78b2b7a0d5dcce",
    //             "branchModuleId": "66ba42f8aba984c8b860ea1c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c4",
    //             "module": {
    //                 "_id": "66b9f23f2b78b2b7a0d5dcce",
    //                 "route_path": "meal_planner",
    //                 "alias_name": "Meal Plan",
    //                 "name": "Meal Plan",
    //                 "parentId": "66aa5073a1fd1f477a64a833",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66bdff8a2b78b2b7a04b038b",
    //             "branchModuleId": "66bf9ac8defda8fa40666ea5",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c5",
    //             "module": {
    //                 "_id": "66bdff8a2b78b2b7a04b038b",
    //                 "route_path": "id_cards",
    //                 "alias_name": "ID cards",
    //                 "name": "ID cards",
    //                 "parentId": "64a3c42ea5b49011b1702e51",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66bdff8a2b78b2b7a04b038d",
    //             "branchModuleId": "66bf9ac8defda8fa40666ea6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c6",
    //             "module": {
    //                 "_id": "66bdff8a2b78b2b7a04b038d",
    //                 "route_path": "student_idcards",
    //                 "alias_name": "Student ID Cards",
    //                 "name": "Student ID Cards",
    //                 "parentId": "66bdff8a2b78b2b7a04b038b",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66bdff8a2b78b2b7a04b038f",
    //             "branchModuleId": "66bf9ac8defda8fa40666ea7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c7",
    //             "module": {
    //                 "_id": "66bdff8a2b78b2b7a04b038f",
    //                 "route_path": "staff_idcards",
    //                 "alias_name": "Staff ID Cards",
    //                 "name": "Staff ID Cards",
    //                 "parentId": "66bdff8a2b78b2b7a04b038b",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66bdff8a2b78b2b7a04b03b9",
    //             "branchModuleId": "66bf9ac8defda8fa40666ea8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c8",
    //             "module": {
    //                 "_id": "66bdff8a2b78b2b7a04b03b9",
    //                 "route_path": "subject_dairy_report",
    //                 "alias_name": "Subject Diary Report",
    //                 "name": "Subject Diary Report",
    //                 "parentId": "64a3c42fa5b49011b1702e7a",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66bdff8a2b78b2b7a04b03bb",
    //             "branchModuleId": "66bf9ac8defda8fa40666ea9",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25c9",
    //             "module": {
    //                 "_id": "66bdff8a2b78b2b7a04b03bb",
    //                 "route_path": "general_dairy_report",
    //                 "alias_name": "General Diary Report",
    //                 "name": "General Diary Report",
    //                 "parentId": "64a3c42fa5b49011b1702e7a",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66c6bfff2b78b2b7a03a29aa",
    //             "branchModuleId": "66c73d87e326908890fa42f0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ca",
    //             "module": {
    //                 "_id": "66c6bfff2b78b2b7a03a29aa",
    //                 "route_path": "penalisation_policy",
    //                 "alias_name": "Penalization Policy",
    //                 "name": "Penalization Policy",
    //                 "parentId": "666982bba1fd1f477a4feb55",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66c73aed2b78b2b7a04b2d30",
    //             "branchModuleId": "66c73d87e326908890fa42f1",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25cb",
    //             "module": {
    //                 "_id": "66c73aed2b78b2b7a04b2d30",
    //                 "route_path": "attributes_creation",
    //                 "alias_name": "Attributes",
    //                 "name": "Attributes",
    //                 "parentId": "64f9e517a5b49011b19ce8d7",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66c73aed2b78b2b7a04b2d32",
    //             "branchModuleId": "66c73d87e326908890fa42f2",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25cc",
    //             "module": {
    //                 "_id": "66c73aed2b78b2b7a04b2d32",
    //                 "route_path": "health_hygenic_creation",
    //                 "alias_name": "Health and Hygenic Details",
    //                 "name": "Health and Hygenic Details",
    //                 "parentId": "64f9e517a5b49011b19ce8d7",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66c73aed2b78b2b7a04b2d39",
    //             "branchModuleId": "66c73d87e326908890fa42f3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25cd",
    //             "module": {
    //                 "_id": "66c73aed2b78b2b7a04b2d39",
    //                 "route_path": "attributes_allocation",
    //                 "alias_name": "Attributes Allocation",
    //                 "name": "Attributes Allocation",
    //                 "parentId": "64f7e3d2a5b49011b1665bb1",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66c73aed2b78b2b7a04b2d3b",
    //             "branchModuleId": "66c73d87e326908890fa42f4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ce",
    //             "module": {
    //                 "_id": "66c73aed2b78b2b7a04b2d3b",
    //                 "route_path": "health_hygenic_allocation",
    //                 "alias_name": "Health and Hygenic Allocation",
    //                 "name": "Health and Hygenic Allocation",
    //                 "parentId": "64f7e3d2a5b49011b1665bb1",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66ce0b292b78b2b7a00f7fe4",
    //             "branchModuleId": "66ceab454bf43ac110da434f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25cf",
    //             "module": {
    //                 "_id": "66ce0b292b78b2b7a00f7fe4",
    //                 "route_path": "general_exams",
    //                 "alias_name": "General Exams",
    //                 "name": "General Exams",
    //                 "parentId": "6503fc11a5b49011b1a67e67",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66ce0b292b78b2b7a00f7fe6",
    //             "branchModuleId": "66ceab454bf43ac110da4350",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d0",
    //             "module": {
    //                 "_id": "66ce0b292b78b2b7a00f7fe6",
    //                 "route_path": "general_exams_creation",
    //                 "alias_name": "Schedule Exam",
    //                 "name": "Schedule Exam",
    //                 "parentId": "66ce0b292b78b2b7a00f7fe4",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66ce0b292b78b2b7a00f7fe9",
    //             "branchModuleId": "66ceab454bf43ac110da4351",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d1",
    //             "module": {
    //                 "_id": "66ce0b292b78b2b7a00f7fe9",
    //                 "route_path": "general_exams_entry",
    //                 "alias_name": "Marks Entry",
    //                 "name": "Marks Entry",
    //                 "parentId": "66ce0b292b78b2b7a00f7fe4",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66d055592b78b2b7a051ad44",
    //             "branchModuleId": "66d08178a4863b04c2499a5a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d2",
    //             "module": {
    //                 "_id": "66d055592b78b2b7a051ad44",
    //                 "route_path": "attendance_bulk_uploads",
    //                 "alias_name": "Bulk Upload",
    //                 "name": "Bulk Upload",
    //                 "parentId": "6503fc11a5b49011b1a67e67",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66d055592b78b2b7a051ad46",
    //             "branchModuleId": "66d08178a4863b04c2499a5b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d3",
    //             "module": {
    //                 "_id": "66d055592b78b2b7a051ad46",
    //                 "route_path": "attendance_bulk_upload",
    //                 "alias_name": "Attendance Bulk Upload",
    //                 "name": "Attendance Bulk Upload",
    //                 "parentId": "66d055592b78b2b7a051ad44",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66d08b1a2b78b2b7a0582a81",
    //             "branchModuleId": "66d353046d9eb3937b581a77",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d4",
    //             "module": {
    //                 "_id": "66d08b1a2b78b2b7a0582a81",
    //                 "route_path": "fee_followup_report",
    //                 "alias_name": "Fee Followup Report",
    //                 "name": "Fee Followup Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1a",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66d08b1e2b78b2b7a0582b60",
    //             "branchModuleId": "66d73d642d8afe4af9e08e03",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d5",
    //             "module": {
    //                 "_id": "66d08b1e2b78b2b7a0582b60",
    //                 "route_path": "academic_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "64a3c42fa5b49011b1702e6f",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66d08b1e2b78b2b7a0582b62",
    //             "branchModuleId": "66d73d642d8afe4af9e08e04",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d6",
    //             "module": {
    //                 "_id": "66d08b1e2b78b2b7a0582b62",
    //                 "route_path": "subject_dairy_submission_report",
    //                 "alias_name": "Subject Dairy Submission Report",
    //                 "name": "Subject Dairy Submission Report",
    //                 "parentId": "66d08b1e2b78b2b7a0582b60",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66d08b1f2b78b2b7a0582bf7",
    //             "branchModuleId": "66d73d642d8afe4af9e08e05",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d7",
    //             "module": {
    //                 "_id": "66d08b1f2b78b2b7a0582bf7",
    //                 "route_path": "general_exams_approval",
    //                 "alias_name": "Marks Approval",
    //                 "name": "Marks Approval",
    //                 "parentId": "66ce0b292b78b2b7a00f7fe4",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66d580a02b78b2b7a0e27dc5",
    //             "branchModuleId": "66d73d642d8afe4af9e08e06",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d8",
    //             "module": {
    //                 "_id": "66d580a02b78b2b7a0e27dc5",
    //                 "route_path": "view_general_exams_marks",
    //                 "alias_name": "View Marks",
    //                 "name": "View Marks",
    //                 "parentId": "66ce0b292b78b2b7a00f7fe4",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66d709e62b78b2b7a00f7ad0",
    //             "branchModuleId": "66d73d642d8afe4af9e08e02",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25d9",
    //             "module": {
    //                 "_id": "66d709e62b78b2b7a00f7ad0",
    //                 "route_path": "unassigned_fee_reports",
    //                 "alias_name": "Unassigned Fee Report",
    //                 "name": "Unassigned Fee Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1a",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66d9a78b2b78b2b7a05db54c",
    //             "branchModuleId": "66e160b078cc50c109014913",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25da",
    //             "module": {
    //                 "_id": "66d9a78b2b78b2b7a05db54c",
    //                 "route_path": "id_card_template_settings",
    //                 "alias_name": "ID Card Template Settings",
    //                 "name": "ID Card Template Settings",
    //                 "parentId": "64a3c42ea5b49011b1702e59",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66e00be22b78b2b7a0119c28",
    //             "branchModuleId": "66e160b078cc50c109014914",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25db",
    //             "module": {
    //                 "_id": "66e00be22b78b2b7a0119c28",
    //                 "route_path": "marks_approval_settings",
    //                 "alias_name": "Marks Approval Settings",
    //                 "name": "Marks Approval Settings",
    //                 "parentId": "66b37b692b78b2b7a0215ccb",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66e00be42b78b2b7a0119c6d",
    //             "branchModuleId": "66e160b078cc50c109014915",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25dc",
    //             "module": {
    //                 "_id": "66e00be42b78b2b7a0119c6d",
    //                 "route_path": "social_post",
    //                 "alias_name": "Social Post",
    //                 "name": "Social Post",
    //                 "route": false,
    //                 "sequenceNumber": 19,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "66e00be42b78b2b7a0119c6f",
    //             "branchModuleId": "66e160b078cc50c109014916",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25dd",
    //             "module": {
    //                 "_id": "66e00be42b78b2b7a0119c6f",
    //                 "route_path": "media_setup",
    //                 "alias_name": "Media Setup",
    //                 "name": "Media Setup",
    //                 "parentId": "66e00be42b78b2b7a0119c6d",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66e00be42b78b2b7a0119c71",
    //             "branchModuleId": "66e160b078cc50c109014917",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25de",
    //             "module": {
    //                 "_id": "66e00be42b78b2b7a0119c71",
    //                 "route_path": "social_media_link",
    //                 "alias_name": "Social Media Link",
    //                 "name": "Social Media Link",
    //                 "parentId": "66e00be42b78b2b7a0119c6f",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66e00be42b78b2b7a0119c73",
    //             "branchModuleId": "66e160b078cc50c109014918",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25df",
    //             "module": {
    //                 "_id": "66e00be42b78b2b7a0119c73",
    //                 "route_path": "media_post",
    //                 "alias_name": "Post",
    //                 "name": "Post",
    //                 "parentId": "66e00be42b78b2b7a0119c6d",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66e00be42b78b2b7a0119c75",
    //             "branchModuleId": "66e160b078cc50c109014919",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e0",
    //             "module": {
    //                 "_id": "66e00be42b78b2b7a0119c75",
    //                 "route_path": "social_media_post",
    //                 "alias_name": "Social Post",
    //                 "name": "Social Post",
    //                 "parentId": "66e00be42b78b2b7a0119c73",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66fb8ed6f3a1b19053041b4e",
    //             "branchModuleId": "6703b91ecb9ded7b7b54f7e3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e1",
    //             "module": {
    //                 "_id": "66fb8ed6f3a1b19053041b4e",
    //                 "route_path": "send_attendance_sms",
    //                 "alias_name": "Send Attendance SMS",
    //                 "name": "Send Attendance SMS",
    //                 "parentId": "64a3c42ea5b49011b1702e17",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66fb8edbf3a1b19053041cbb",
    //             "branchModuleId": "66fbb13383d0e1687a14a593",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e2",
    //             "module": {
    //                 "_id": "66fb8edbf3a1b19053041cbb",
    //                 "route_path": "online_class",
    //                 "alias_name": "Online Class",
    //                 "name": "Online Class",
    //                 "route": false,
    //                 "sequenceNumber": 20,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "66fb8edbf3a1b19053041cbd",
    //             "branchModuleId": "66fbb13383d0e1687a14a594",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e3",
    //             "module": {
    //                 "_id": "66fb8edbf3a1b19053041cbd",
    //                 "route_path": "online_classes",
    //                 "alias_name": "Online Classes",
    //                 "name": "Online Classes",
    //                 "parentId": "66fb8edbf3a1b19053041cbb",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "66fb8edbf3a1b19053041cbf",
    //             "branchModuleId": "66fbb13383d0e1687a14a595",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e4",
    //             "module": {
    //                 "_id": "66fb8edbf3a1b19053041cbf",
    //                 "route_path": "schedule_online_class",
    //                 "alias_name": "Schedule Online Class",
    //                 "name": "Schedule Online Class",
    //                 "parentId": "66fb8edbf3a1b19053041cbd",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66fcdbe8f3a1b19053296628",
    //             "branchModuleId": "66fcdc31703ae2614c2e984d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e5",
    //             "module": {
    //                 "_id": "66fcdbe8f3a1b19053296628",
    //                 "route_path": "external_fee_bulk_upload",
    //                 "alias_name": "Bulk Upload",
    //                 "name": "Bulk Upload",
    //                 "parentId": "64a3c42ca5b49011b1702d14",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "66fcdbecf3a1b19053296767",
    //             "branchModuleId": "6704395597c31fe4e5f1febd",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e6",
    //             "module": {
    //                 "_id": "66fcdbecf3a1b19053296767",
    //                 "route_path": "assign_subject_students",
    //                 "alias_name": "Student Wise Subject Mapping",
    //                 "name": "Student Wise Subject Mapping",
    //                 "parentId": "64a3c42fa5b49011b1702e71",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6703b370f3a1b19053e7f766",
    //             "branchModuleId": "6704395597c31fe4e5f1febe",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e7",
    //             "module": {
    //                 "_id": "6703b370f3a1b19053e7f766",
    //                 "route_path": "diary_creation_settings",
    //                 "alias_name": "Diary Creation Settings",
    //                 "name": "Diary Creation Settings",
    //                 "parentId": "66837f15a1fd1f477a2884c2",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6703b371f3a1b19053e7f7ef",
    //             "branchModuleId": "6704395597c31fe4e5f1febf",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e8",
    //             "module": {
    //                 "_id": "6703b371f3a1b19053e7f7ef",
    //                 "route_path": "online_class_reports",
    //                 "alias_name": "Reports",
    //                 "name": "Reports",
    //                 "parentId": "66fb8edbf3a1b19053041cbb",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6703b371f3a1b19053e7f7f1",
    //             "branchModuleId": "6704395597c31fe4e5f1fec0",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25e9",
    //             "module": {
    //                 "_id": "6703b371f3a1b19053e7f7f1",
    //                 "route_path": "online_class_attendance_report",
    //                 "alias_name": "Online Class Attendance Report",
    //                 "name": "Online Class Attendance Report",
    //                 "parentId": "6703b371f3a1b19053e7f7ef",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "67076e16f3a1b1905351ee70",
    //             "branchModuleId": "67077d1f3fa03007b3f0996f",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ea",
    //             "module": {
    //                 "_id": "67076e16f3a1b1905351ee70",
    //                 "route_path": "agent_tracking",
    //                 "alias_name": "Agent Tracking",
    //                 "name": "Agent Tracking",
    //                 "parentId": "64a3c42da5b49011b1702d54",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "67076e16f3a1b1905351ee76",
    //             "branchModuleId": "67077d1f3fa03007b3f09970",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25eb",
    //             "module": {
    //                 "_id": "67076e16f3a1b1905351ee76",
    //                 "route_path": "crm/live_tracking",
    //                 "alias_name": "Live Tracking",
    //                 "name": "Live Tracking",
    //                 "parentId": "67076e16f3a1b1905351ee70",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "67076e16f3a1b1905351ee8a",
    //             "branchModuleId": "67077d1f3fa03007b3f09971",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ec",
    //             "module": {
    //                 "_id": "67076e16f3a1b1905351ee8a",
    //                 "route_path": "crm/task_settings",
    //                 "alias_name": "Task Number Settings",
    //                 "name": "Task Number Settings",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 10,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a240f3a1b1905313957a",
    //             "branchModuleId": "6717a261346b082299419a99",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ed",
    //             "module": {
    //                 "_id": "6717a240f3a1b1905313957a",
    //                 "route_path": "assessments",
    //                 "alias_name": "Assessments",
    //                 "name": "Assessments",
    //                 "route": false,
    //                 "sequenceNumber": 21,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a240f3a1b1905313957c",
    //             "branchModuleId": "6717a261346b082299419a9a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ee",
    //             "module": {
    //                 "_id": "6717a240f3a1b1905313957c",
    //                 "route_path": "assessment_setup",
    //                 "alias_name": "Assessment Setup",
    //                 "name": "Assessment Setup",
    //                 "parentId": "6717a240f3a1b1905313957a",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a240f3a1b19053139580",
    //             "branchModuleId": "6717a261346b082299419a9c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ef",
    //             "module": {
    //                 "_id": "6717a240f3a1b19053139580",
    //                 "route_path": "taxanomy",
    //                 "alias_name": "Taxanomy",
    //                 "name": "Taxanomy",
    //                 "parentId": "6717a240f3a1b1905313957c",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a240f3a1b19053139582",
    //             "branchModuleId": "6717a261346b082299419a9d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f0",
    //             "module": {
    //                 "_id": "6717a240f3a1b19053139582",
    //                 "route_path": "difficulty_level",
    //                 "alias_name": "Difficulty Level",
    //                 "name": "Difficulty Level",
    //                 "parentId": "6717a240f3a1b1905313957c",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a4f9f3a1b1905313fc9e",
    //             "branchModuleId": "6717b005d5e2ce00904bfbe6",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f1",
    //             "module": {
    //                 "_id": "6717a4f9f3a1b1905313fc9e",
    //                 "route_path": "lesson_delivery",
    //                 "alias_name": "Lesson Delivery",
    //                 "name": "Lesson Delivery",
    //                 "route": false,
    //                 "sequenceNumber": 22,
    //                 "type": "module"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a4f9f3a1b1905313fca1",
    //             "branchModuleId": "6717b005d5e2ce00904bfbe7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f2",
    //             "module": {
    //                 "_id": "6717a4f9f3a1b1905313fca1",
    //                 "route_path": "lesson_setup",
    //                 "alias_name": "Lesson Setup",
    //                 "name": "Lesson Setup",
    //                 "parentId": "6717a4f9f3a1b1905313fc9e",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a4f9f3a1b1905313fcb7",
    //             "branchModuleId": "6717b005d5e2ce00904bfbe8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f3",
    //             "module": {
    //                 "_id": "6717a4f9f3a1b1905313fcb7",
    //                 "route_path": "lesson_creation",
    //                 "alias_name": "Lesson Creation",
    //                 "name": "Lesson Creation",
    //                 "parentId": "6717a4f9f3a1b1905313fca1",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6717a4f9f3a1b1905313fcb9",
    //             "branchModuleId": "6717b05bd5e2ce00904bff7c",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f4",
    //             "module": {
    //                 "_id": "6717a4f9f3a1b1905313fcb9",
    //                 "route_path": "lesson_plan/settings",
    //                 "alias_name": "Lesson Plan Setting",
    //                 "name": "Lesson Plan Setting",
    //                 "parentId": "6717a4f9f3a1b1905313fca1",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6718ab41f3a1b19053317b01",
    //             "branchModuleId": "6719bf714fd20281040e6fc8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f5",
    //             "module": {
    //                 "_id": "6718ab41f3a1b19053317b01",
    //                 "route_path": "external_concession_bulk_upload",
    //                 "alias_name": "Concession Bulk Upload",
    //                 "name": "Concession Bulk Upload",
    //                 "parentId": "64a3c42ca5b49011b1702d14",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "671b1769f3a1b1905377692e",
    //             "branchModuleId": "671dee6ff8efcd2e5e6d56f8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f6",
    //             "module": {
    //                 "_id": "671b1769f3a1b1905377692e",
    //                 "route_path": "part_term_settings",
    //                 "alias_name": "Part/Term Settings",
    //                 "name": "Part/Term Settings",
    //                 "parentId": "6717a4f9f3a1b1905313fca1",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "672505e9f3a1b1905387e960",
    //             "branchModuleId": "672508d469e1fb3c085308a7",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f7",
    //             "module": {
    //                 "_id": "672505e9f3a1b1905387e960",
    //                 "route_path": "lesson_planning",
    //                 "alias_name": "Lesson Planner",
    //                 "name": "Lesson Planner",
    //                 "parentId": "672aedc2f3a1b190532ae17b",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "672505e9f3a1b1905387e962",
    //             "branchModuleId": "672508d469e1fb3c085308a8",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f8",
    //             "module": {
    //                 "_id": "672505e9f3a1b1905387e962",
    //                 "route_path": "lesson_delivery_plan",
    //                 "alias_name": "Lesson Delivery",
    //                 "name": "Lesson Delivery",
    //                 "parentId": "672aedc2f3a1b190532ae17b",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "672aedc2f3a1b190532ae17b",
    //             "branchModuleId": "672bb457e1bdbe7eaa891cab",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25f9",
    //             "module": {
    //                 "_id": "672aedc2f3a1b190532ae17b",
    //                 "route_path": "lesson_delivery_planning",
    //                 "alias_name": "Lesson Planning",
    //                 "name": "Lesson Planning",
    //                 "parentId": "6717a4f9f3a1b1905313fc9e",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "672df321f3a1b1905382c8fd",
    //             "branchModuleId": "672df32fac78b0842bd8f1ed",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25fa",
    //             "module": {
    //                 "_id": "672df321f3a1b1905382c8fd",
    //                 "route_path": "question_setup",
    //                 "alias_name": "Question Setup",
    //                 "name": "Question Setup",
    //                 "parentId": "6717a240f3a1b1905313957a",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "672df321f3a1b1905382c8ff",
    //             "branchModuleId": "672df32fac78b0842bd8f1ee",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25fb",
    //             "module": {
    //                 "_id": "672df321f3a1b1905382c8ff",
    //                 "route_path": "question_bank",
    //                 "alias_name": "Question Bank",
    //                 "name": "Question Bank",
    //                 "parentId": "672df321f3a1b1905382c8fd",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "672df784f3a1b19053835719",
    //             "branchModuleId": "672f8184c4f0cef113b7cbf4",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25fc",
    //             "module": {
    //                 "_id": "672df784f3a1b19053835719",
    //                 "route_path": "concession_reports",
    //                 "alias_name": "Student Wise Concession Report",
    //                 "name": "Student Wise Concession Report",
    //                 "parentId": "64a3c42ca5b49011b1702d32",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "673d6587f3a1b19053373a3c",
    //             "branchModuleId": "67487e0ebe8ac38dbd3e0b62",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25fd",
    //             "module": {
    //                 "_id": "673d6587f3a1b19053373a3c",
    //                 "route_path": "class_wise_concession_reports",
    //                 "alias_name": "Class Wise Concession Report",
    //                 "name": "Class Wise Concession Report",
    //                 "parentId": "64a3c42ca5b49011b1702d32",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6740773a1c6dabd1984d77fd",
    //             "branchModuleId": "6740c6689d8326eb94259a63",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25fe",
    //             "module": {
    //                 "_id": "6740773a1c6dabd1984d77fd",
    //                 "route_path": "my_assessment",
    //                 "alias_name": "My Assessment",
    //                 "name": "My Assessment",
    //                 "parentId": "6717a240f3a1b1905313957c",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "674816d41c6dabd198215afa",
    //             "branchModuleId": "67487e0ebe8ac38dbd3e0b61",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d25ff",
    //             "module": {
    //                 "_id": "674816d41c6dabd198215afa",
    //                 "route_path": "sibling_due_report",
    //                 "alias_name": "Sibling Due Report",
    //                 "name": "Sibling Due Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1f",
    //                 "route": false,
    //                 "sequenceNumber": 8,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "674816db1c6dabd198215cf1",
    //             "branchModuleId": "67487e0ebe8ac38dbd3e0b63",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2600",
    //             "module": {
    //                 "_id": "674816db1c6dabd198215cf1",
    //                 "route_path": "assessment_library",
    //                 "alias_name": "Assessment Library",
    //                 "name": "Assessment Library",
    //                 "parentId": "6717a240f3a1b1905313957c",
    //                 "route": false,
    //                 "sequenceNumber": 4,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6756a5621c6dabd198b8580c",
    //             "branchModuleId": "6756c560c214f7b058b8ca8d",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2601",
    //             "module": {
    //                 "_id": "6756a5621c6dabd198b8580c",
    //                 "route_path": "map_to_branches",
    //                 "alias_name": "Assign To Branches",
    //                 "name": "Assign To Branches",
    //                 "parentId": "64a3c42ea5b49011b1702de9",
    //                 "route": false,
    //                 "sequenceNumber": 6,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d23",
    //             "branchModuleId": "675729f7c214f7b058b96712",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2618",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d23",
    //                 "route_path": "total_paid_and_due_report",
    //                 "alias_name": "Total Paid and Due Report",
    //                 "name": "Total Paid and Due Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1f",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d2c",
    //             "branchModuleId": "675729f7c214f7b058b96715",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d261a",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d2c",
    //                 "route_path": "branch_wise_due_report",
    //                 "alias_name": "Branch Wise Due Report",
    //                 "name": "Branch Wise Due Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1f",
    //                 "route": false,
    //                 "sequenceNumber": 5,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42ca5b49011b1702d2e",
    //             "branchModuleId": "675729f7c214f7b058b96717",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d261b",
    //             "module": {
    //                 "_id": "64a3c42ca5b49011b1702d2e",
    //                 "route_path": "fee_outstanding_report",
    //                 "alias_name": "Fee Outstanding Report",
    //                 "name": "Fee Outstanding Report",
    //                 "parentId": "64a3c42ca5b49011b1702d1f",
    //                 "route": false,
    //                 "sequenceNumber": 7,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d4c",
    //             "branchModuleId": "675729f7c214f7b058b96729",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2626",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d4c",
    //                 "route_path": "approve_branch_shuffling_requests",
    //                 "alias_name": "Branch Shuffling Requests",
    //                 "name": "Branch Shuffling Requests",
    //                 "parentId": "64a3c42da5b49011b1702d4a",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "64a3c42da5b49011b1702d50",
    //             "branchModuleId": "675729f7c214f7b058b9672b",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d2628",
    //             "module": {
    //                 "_id": "64a3c42da5b49011b1702d50",
    //                 "route_path": "approve_student_fee_refunds",
    //                 "alias_name": "Student Fee Refund Requests",
    //                 "name": "Student Fee Refund Requests",
    //                 "parentId": "64a3c42da5b49011b1702d4a",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6756a5611c6dabd198b857bb",
    //             "branchModuleId": "675729f7c214f7b058b9674a",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d279c",
    //             "module": {
    //                 "_id": "6756a5611c6dabd198b857bb",
    //                 "route_path": "org_stream",
    //                 "alias_name": "Organization Streams",
    //                 "name": "Organization Streams",
    //                 "parentId": "64a3c42da5b49011b1702d63",
    //                 "route": false,
    //                 "sequenceNumber": 9,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6763b6331c6dabd19862024e",
    //             "branchModuleId": "67769901533e3c2146f74c55",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d279e",
    //             "module": {
    //                 "_id": "6763b6331c6dabd19862024e",
    //                 "route_path": "asset_addition",
    //                 "alias_name": "Asset Addition",
    //                 "name": "Asset Addition",
    //                 "parentId": "6763b6b71c6dabd19862346a",
    //                 "route": false,
    //                 "sequenceNumber": 1,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6763b6b71c6dabd19862346a",
    //             "branchModuleId": "67769901533e3c2146f74c54",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d279f",
    //             "module": {
    //                 "_id": "6763b6b71c6dabd19862346a",
    //                 "route_path": "asset_management",
    //                 "alias_name": "Asset Management",
    //                 "name": "Asset Management",
    //                 "parentId": "65377d59a5b49011b1548a4c",
    //                 "route": false,
    //                 "sequenceNumber": 3,
    //                 "type": "submodule"
    //             }
    //         },
    //         {
    //             "moduleId": "6763c3dc1c6dabd19863e8e0",
    //             "branchModuleId": "67769901533e3c2146f74c53",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d27a0",
    //             "module": {
    //                 "_id": "6763c3dc1c6dabd19863e8e0",
    //                 "route_path": "crm/call_history",
    //                 "alias_name": "Call History",
    //                 "name": "Call History",
    //                 "parentId": "67076e16f3a1b1905351ee70",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "676410fc1c6dabd198700b5c",
    //             "branchModuleId": "67769901533e3c2146f74c56",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d27a1",
    //             "module": {
    //                 "_id": "676410fc1c6dabd198700b5c",
    //                 "route_path": "issued_staff_items",
    //                 "alias_name": "Issued Staff Items",
    //                 "name": "Issued Staff Items",
    //                 "parentId": "6763b6b71c6dabd19862346a",
    //                 "route": false,
    //                 "sequenceNumber": 2,
    //                 "type": "submoduleroute"
    //             }
    //         },
    //         {
    //             "moduleId": "6776004f1c6dabd1985def11",
    //             "branchModuleId": "67778b1f533e3c2146f79fe3",
    //             "dashlets": [],
    //             "_id": "67ac57482f07d6984e3d27a2",
    //             "module": {
    //                 "_id": "6776004f1c6dabd1985def11",
    //                 "route_path": "application_fee_settings",
    //                 "alias_name": "Application Fee Settings",
    //                 "name": "Application Fee Settings",
    //                 "parentId": "64a3c42ca5b49011b1702d39",
    //                 "route": false,
    //                 "sequenceNumber": 8,
    //                 "type": "submoduleroute"
    //             }
    //         }
    //     ]
    //   }
      if(data){
        datadogRum.setUser({
          id: data._id,
          name: data.username || data.email || 'unknown_user',
          email: data.email || 'unknown_email',
          // schoolName: data?.organization?.[0]?.account_name || 'unknown_school',
          schoolName: 'unknown_school',
        })
      }
      dispatch({
        type: types.USER_LOADED,
        payload: data
      });
    } catch (error) {
        console.log(error);
      dispatch({ type: types.USER_AUTH_ERROR });
    }
  };

// LOGIN USER
export const loginUser =
  (body: any, navigate: any) => async (dispatch: Dispatch<UserActions>) => {
    // const config = await setClientDetailsInHeaders('default')
    
    try {
      const { data } = await axios.post(`user/login`, { ...body, deviceType: "WebApp" });
      dispatch({
        type: types.USER_LOGIN_SUCCESS,
        payload: data,
      });
      dispatch<any>(
        setAlert({
          msg: "Login Successful!",
          status: 200,
          alertType: "success",
        })
      );
      dispatch<any>(loadUser(null));
      if (localStorage.isPasswordRest) {
        navigate("/reset_password");
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      dispatch({ type: types.USER_LOGIN_FAIL });
      if (error?.response?.data?.info) {
        dispatch<any>(
          setAlert({
            msg: error?.response?.data?.message ?? "Invalid Username/Password",
            status: 500,
            alertType: "danger",
          })
        );
      } else {
        dispatch<any>(
          setAlert({
            msg: "Invalid Username/Password",
            status: 500,
            alertType: "danger",
          })
        );
      }
    }
  };

  // OTP LOGIN USER
export const verifyOtpLogin =
(body: any, navigate: any) => async (dispatch: Dispatch<UserActions>) => {
  // const config = await setClientDetailsInHeaders('default')
  
  try {
    const { data } = await axios.post(`user/admin/web/verifyOtp`, { ...body, deviceType: "web" });
    dispatch({
      type: types.USER_LOGIN_SUCCESS,
      payload: data?.data,
    });
    dispatch<any>(
      setAlert({
        msg: "Login Successful!",
        status: 200,
        alertType: "success",
      })
    );
    dispatch<any>(loadUser(null));
    navigate("/dashboard")
  } catch (error) {
    dispatch({ type: types.USER_LOGIN_FAIL });
    if (error?.response?.data?.info) {
      dispatch<any>(
        setAlert({
          msg: error?.response?.data?.message ?? "Invalid Login Attempt..!",
          status: 500,
          alertType: "danger",
        })
      );
    } else {
      dispatch<any>(
        setAlert({
          msg: "Invalid Login Attempt..!",
          status: 500,
          alertType: "danger",
        })
      );
    }
  }
};

export const switchUserAccount =
  (body: any, navigate?: any) => async (dispatch: Dispatch<UserActions>) => {
    // const config = await setClientDetailsInHeaders('default')
    
    try {
      const { data } = await axios.post(`user/switchAccount`, { ...body, deviceType: "WebApp" });
      dispatch({
        type: ActionTypes.USER_SWITCH_SUCCESS,
        payload: data,
      });
      dispatch<any>(
        setAlert({
          msg: "Switch Successful!",
          status: 200,
          alertType: "success",
        })
      );
      dispatch<any>(loadUser(null));
      navigate("/dashboard");
    } catch (error) {
      console.log(error)
      dispatch({ type: ActionTypes.USER_SWITCH_FAIL });
      if (error?.response?.data?.message) {
        dispatch<any>(
          setAlert({
            msg: error?.response?.data?.message ?? "Invalid Username/Password",
            status: 500,
            alertType: "danger",
          })
        );
      } else {
        dispatch<any>(
          setAlert({
            msg: "Invalid Username/Password",
            status: 500,
            alertType: "danger",
          })
        );
      }
    }
  };

// REGISTER USER
export const registerUser =
  (body: any, setSubmitting: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(`user/register`, body, config);
        dispatch({
          type: types.USER_REGISTER_SUCCESS,
          payload: data,
        });


      } catch (error) {
        dispatch({ type: types.USER_REGISTER_FAIL });
      } finally {
        setSubmitting(false);
      }
    };

export const registerStaffdetails =
  (body: any, setSubmitting: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      if (localStorage.user__token) setUserAuthToken(localStorage.user__token, localStorage.use_role_level);
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(`user/create/staff`, body, config);
        dispatch({
          type: types.USER_CREATION_SUCCESS,
          payload: data,
        });
        dispatch<any>(
          setAlert({
            msg: "Staff Created successfully!",
            status: 200,
            alertType: "success",
          })
        );
        return data;
      } catch (error) {
        dispatch({ type: types.USER_REGISTER_FAIL });
        dispatch<any>(
          setAlert({
            msg: error?.response?.data?.message ?? "Something went wrong when creating staff",
            status: error?.response?.status,
            alertType: "danger",
          })
        );
        return "";
      }
    };

// GET USERS
export const getUsers = () => async (dispatch: Dispatch<UserActions>) => {
  const config: any = {
    header: {
      "Content-Type": "application/json",
    },
  };

  try {
    const { data } = await axios.get(`user/users`, config);
    dispatch({ type: types.GET_USERS, payload: data });
  } catch (error) { }
};
// GET USERDETAILS
export const getUserdetails = () => async (dispatch: Dispatch<UserActions>) => {
  const config: any = {
    header: {
      "Content-Type": "application/json",
    },
  };

  try {
    const { data } = await axios.get(`user/users`, config);
    dispatch({ type: types.GET_USERDETAILS, payload: data });
  } catch (error) { }
};

// GET USER PERMISSIONS
export const getUserPermissions = (obj: any, setPreviousRole: any) => async (dispatch: Dispatch<UserActions>) => {
  const config: any = {
    header: {
      "Content-Type": "application/json",
    },
  };

  try {
    const { data } = await axios.post(`user/getpermission`, obj, config);
    dispatch({ type: types.USER_PERMISSIONS_LOADED, payload: data });
  } catch (error) {
    setPreviousRole();
    dispatch<any>(
      setAlert({
        msg: "Permissions not assigned to this role",
        status: 500,
        alertType: "danger",
      })
    );
  }
};

// UPDATE USER DATA
export const updateUser =
  (body: any, id: any, setSubmitting: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.patch(`user/users/${id}`, body, config);
        dispatch({
          type: types.UPDATE_USER,
          payload: data,
        });
        dispatch<any>(getUsers());
      } catch (error) {
      } finally {
        setSubmitting(false);
      }
    };


// export const updateStaff =
//   (body: any, id: any, setSubmitting: any) =>
//     async (dispatch: Dispatch<UserActions>) => {
//       const config: any = {
//         header: {
//           "Content-Type": "application/json",
//         },
//       };

//       try {
//         const { data } = await axios.put(`user/update/${id}`, body, config);
//         dispatch({
//           type: types.UPDATE_USER,
//           payload: data,
//         });
//         dispatch<any>(
//           setAlert({
//             msg: "Updating Student Successful",
//             status: 200,
//             alertType: "success",
//           })
//         );
//         // dispatch<any>(getUsers());
//       } catch (error) {
//       } 
//       finally {
//         if (setSubmitting)
//           setSubmitting(false);
//       }
//     };

export const updateStudent =
  (body: any, id: any, setSubmitting: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        if (localStorage.user__token) setUserAuthToken(localStorage.user__token, localStorage.use_role_level);
        const { data } = await axios.put(`student/update/${id}`, body, config);
        dispatch({
          type: types.UPDATE_USER,
          payload: data,
        });
        dispatch<any>(
          setAlert({
            msg: "Updating Student Successful",
            status: 200,
            alertType: "success",
          })
        );
        // dispatch<any>(getUsers());
      } catch (error) {
      }
      finally {
        if (setSubmitting)
          setSubmitting(false);
      }
    };

export const updateBulkStudents =
  (body: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        if (localStorage.user__token) setUserAuthToken(localStorage.user__token, localStorage.use_role_level);
        const { data } = await axios.post(`student/bulkstudentupdate`, body, config);
        dispatch({
          type: types.UPDATE_STUDENTS_BULK,
          payload: data,
        });
        dispatch<any>(
          setAlert({
            msg: "Updating Students Successful",
            status: 200,
            alertType: "success",
          })
        );
        // dispatch<any>(getUsers());
      } catch (error) {
        const msg = error?.response?.data?.message ?? "Something went wrong when updating students";
        dispatch<any>(setAlert(
          {
            msg: msg,
            status: 500,
            alertType: "danger",
          }
        ))
      }
    };

export const studentsPasswordGeneration =
  (body: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(`student/bulkresetpassword`, body, config);
        dispatch({
          type: types.BULK_STUDENT_PASSWORD_GENERATION,
          payload: data,
        });
        dispatch<any>(
          setAlert({
            msg: "Password Generation Successful",
            status: 200,
            alertType: "success",
          })
        );
        // dispatch<any>(getUsers());
      } catch (error) {
        dispatch<any>(setAlert(
          {
            msg: "Something went wrong when generating passwords for students",
            status: 500,
            alertType: "danger",
          }
        ))
      }
    };
// STUDENT INDIVIDUAL PASSWORD GENERATION

export const singlestudentsPassword =
  (body: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(`student/updatestudentspassword`, body, config);
        dispatch({
          type: types.BULK_STUDENT_PASSWORD_GENERATION,
          payload: data,
        });
        dispatch<any>(
          setAlert({
            msg: "Password Generation Successful",
            status: 200,
            alertType: "success",
          })
        );
        // dispatch<any>(getUsers());
      } catch (error) {
        dispatch<any>(setAlert(
          {
            msg: "Something went wrong when generating passwords for students",
            status: 500,
            alertType: "danger",
          }
        ))
      }
    };

// DELETE USER
export const deleteUser =
  (id: number) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      await axios.delete(`user/users/${id}`, config);
      dispatch({ type: types.DELETE_USER, payload: id });
    } catch (error) { }
  };
// LOGOUT USER
export const logOutUser =
  (navigate: any) => (dispatch: Dispatch<UserActions>) => {
    dispatch({ type: types.USER_LOGOUT });
    dispatch<any>({ type: ActionTypes.LOGOUT_PROFILE });
    dispatch<any>({ type: ActionTypes.LOGOUT_ORGANIZATION });
    dispatch<any>({ type: ActionTypes.LOGOUT_BRANCH });
    navigate("/dashboard");
  };

export const getStudentsandStaff =
  (body: any, setIsLoading?: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.post(`student/getStudents`, body, config);
      dispatch({ type: types.GET_USERDETAILS, payload: data });
    } catch (error: any) {
      dispatch<any>(
        setAlert({
          msg: "Something went wrong when fetching the getusers!",
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    } finally {
      if (setIsLoading)
        setIsLoading(false);
    }
  };
export const getFeePlanStudents =
  (body: any, setIsLoading?: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.post(`student/getFeePlanStudents`, body, config);
      dispatch({ type: types.GETFEEPLAN_STUDENTS, payload: data });
    } catch (error: any) {
      dispatch<any>(
        setAlert({
          msg: "Something went wrong when fetching the getusers!",
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    } finally {
      if (setIsLoading) {
        setIsLoading(false);
      }
    }
  };

export const getFeeTypeStudents =
  (body: any, setIsLoading?: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.post(`student/getFeeTypeStudents`, body, config);
      dispatch({ type: types.GETFEETYPE_STUDENTS, payload: data });
    } catch (error: any) {

      dispatch<any>(
        setAlert({
          msg: error.response.data.message,
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    } finally {
      if (setIsLoading) {
        setIsLoading(false);
      }
    }
  };

export const searchStudents =
  (body: any, setIsLoading?: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      if (setIsLoading) {
        setIsLoading(true);
      }
      const { data } = await axios.post(`student/search`, body, config);
      dispatch({ type: types.SEARCH_USERDETAILS, payload: data });
    } catch (error: any) {
      dispatch<any>(
        setAlert({
          msg: "Something went wrong when fetching the getusers!",
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    } finally {
      if (setIsLoading)
        setIsLoading(false);
    }
  };


export const getstaffDetails =
  (body: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.post(`user/getStaff`, body, config);
      dispatch({ type: types.GET_STAFFDETAILS, payload: data.data });
    } catch (error: any) {
      dispatch<any>(
        setAlert({
          msg: "Something went wrong when fetching the getusers!",
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    }
  };
export const getStudent =
  (body: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(`student/getStudent`, body, config);
        dispatch({
          type: types.GET_STUDENT,
          payload: data,
        });


      } catch (error: any) {
        dispatch<any>(
          setAlert({
            msg: "Something went wrong when fetching the getusers!",
            status: error?.response?.status,
            alertType: "danger",
          })
        );
      }
    };

export const getStudentJourney =
  (body: any) =>
    async (dispatch: Dispatch<UserActions>) => {

      dispatch({
        type: types.GET_STUDENT_JOURNEY_REQUEST,
      });

      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(`student/getJourney`, body, config);
        dispatch({
          type: types.GET_STUDENT_JOURNEY,
          payload: data?.data,
        });


      } catch (error: any) {
        dispatch({
          type: types.GET_STUDENT_JOURNEY_FAILURE,
        });
        const message = error?.response?.data?.message ? error?.response?.data?.message : "Something went wrong when getting the Journey!";
        dispatch<any>(
          setAlert({
            msg: message,
            status: error?.response?.status,
            alertType: "danger",
          })
        );
      }
    };

// Staff

export const getstaff =
  (body: any, setIsLoading?: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.post(`staff/getstaff`, body, config);
      dispatch({ type: types.GET_STAFFDETAILS, payload: data.data });
    } catch (error: any) {
      dispatch<any>(
        setAlert({
          msg: "Something went wrong when getting the staffs!",
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    } finally {
      if (setIsLoading)
        setIsLoading(false);
    }
  };
export const filterstaff =
  (body: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.post(`staff/filterstaff`, body, config);

      dispatch({ type: types.FILTER_STAFFDETAILS, payload: data.data });
    } catch (error: any) {
      dispatch<any>(
        setAlert({
          msg: "Something went wrong when filtering the staffs!",
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    }
  };

export const updatestaff =
  (id: any, body: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.put(`staff/updatestaff/${id}`, body, config);
      dispatch({ type: types.UPDATE_STAFFDETAILS, payload: data.data });
      dispatch<any>(
        setAlert({
          msg: " staff details updated successfully",
          status: 200,
          alertType: "success",
        })
      );
    } catch (error: any) {      
      dispatch<any>(
        setAlert({
          msg: error?.response?.data?.message ?? "Something went wrong when updating staff",
          status: error?.response?.status,
          alertType: "danger",
        })
      );
    }
  };

export const updateBulkStaff =
  (body: any, setIsLoading: any) => async (dispatch: Dispatch<UserActions>) => {
    const config: any = {
      header: {
        "Content-Type": "application/json",
      },
    };

    try {
      const { data } = await axios.post(`staff/updatebulk`, body, config);
      dispatch({ type: types.UPDATE_STAFFDETAILS, payload: data.data });
      dispatch<any>(
        setAlert({
          msg: " staff details updated successfully",
          status: 200,
          alertType: "success",
        })
      );
    } catch (error: any) {
      // dispatch<any>(
      //   setAlert({
      //     msg: "Something went wrong when updating staff details!",
      //     status: error?.response?.status,
      //     alertType: "danger",
      //   })
      // );
    }
    finally {
      if (setIsLoading)
        setIsLoading(false);
    }
  };

export const userPasswordGeneration =
  (body: any) =>
    async (dispatch: Dispatch<UserActions>) => {
      const config: any = {
        header: {
          "Content-Type": "application/json",
        },
      };

      try {
        const { data } = await axios.post(`user/bulkresetpassword`, body, config);
        dispatch({
          type: types.BULK_USER_PASSWORD_GENERATION,
          payload: data,
        });
        dispatch<any>(
          setAlert({
            msg: "Password Generation Successful",
            status: 200,
            alertType: "success",
          })
        );
        // dispatch<any>(getUsers());
      } catch (error) {
        dispatch<any>(setAlert(
          {
            msg: "Something went wrong when generating passwords for students",
            status: 500,
            alertType: "danger",
          }
        ))
      }
    };
